/* ==========================================================================
   TNF CATALOGUE product page controller 1.13.0                  2026-10-02
   1.13.0 (UK launch): a third market, the UK storefront - GBP, centimetres on the AU grid, the UK / IRELAND plug,
   "£" prices and "Includes VAT of £x". AU and US behave exactly as 1.12.1.
   TNF CATALOGUE product page controller 1.12.1                  2026-09-27
   1.12.1 (Jack, 27 Sep: "US customer-facing sizes ... must use inches"): the US page no longer shows the small
   "made to 12.7x162 cm" note beside the size - US customers see inches only. The factory's centimetres still travel
   on the order line as the hidden _tnf_size_cm. Nothing else changed from 1.12.0.
   TNF CATALOGUE product page controller 1.12.0                  2026-09-26
   1.12.0 (Jack, 26 Sep: "The customer should see ONE line: Sign Size: 5 × 64 in"): the order line the page builds
   follows the order module 1.6.0 contract - 'Sign Size' is the customer's one size line in their own unit (US
   "5 × 64 in", AU "35 × 17.8 cm"); 'Sign Size (as ordered)' is gone; the factory's centimetre size (the text
   'Sign Size' carried before, "12.7x162") and the packing plan are hidden properties (_tnf_size_cm,
   _tnf_supplied_in) that checkout and the order status page never show. The note under the size selector (made in
   two sections / sections) and the page's own summary are unchanged. Nothing else changed from 1.11.0.
   TNF CATALOGUE product page controller 1.11.0                  2026-09-26
   1.11.0 (Jack, 26 Sep: "Add to cart ... the delay is noticeably too long"): a fast, confirmed Add to cart.
   Measured with 1.10.0 on the preview (live-test service): 10-12 s for a new configuration, 4.3-5.5 s for a repeat.
   The order service's product creation was most of it (fixed in the service, 1.3.0); on the page: the quote round
   trip before every order, a CORS preflight before each service call, a cart read after the order, and loading the
   whole /cart page. Now:
   - the press is acknowledged at once: both buttons say "Adding..." with a spinner and a second press does nothing;
   - the service is asked for its quote in the background once the configuration settles (700 ms), so the press goes
     straight to the order - the server still prices the exact configuration and signs it, and refuses an order for
     anything else (a stale or refused quote is fetched again once, automatically);
   - service calls are sent as text/plain: no preflight round trip;
   - the cart is read (for the no-double-add rule) while the order is being made, not after it;
   - success is shown only once Shopify has answered the add AND the cart itself holds the sign; then the store's own
     side cart opens with it (the same drawer every other product opens; the /cart page if the drawer isn't there);
   - a brand-new product is added 1 s after the order answers (Shopify's cart refuses a new variant it doesn't know
     yet, and then keeps refusing it for minutes); if it is refused anyway, the service (1.3.0) replaces the product
     and the replacement is added after a longer pause (at most twice);
   - clear messages for a timeout, no connection and a busy service - nothing is ever reported added unless it is;
   - every press leaves its timings in window.__tnfCatLastAdd (ms since the press, with the service's own).
   1.10.0 (Jack's brief of 26 Sep 2026):
   - GRADE P: the 43 designs whose tube measurement remains uncertain are
     priced from their product size records (registry 1.7.0, engine 2.6.9
     'records' basis) - a pricing policy, not a measurement. Such a design
     is priced while its records are complete, open at the product's own
     smallest size and its cost-model estimate belongs to the product's
     current reference size - the same rule as order module 1.4.0. Nothing
     about it is shown to the customer beyond the price.
   - THE 240 cm LIMIT: neither width nor height may exceed 240 cm. The
     slider, the number box, the - / + buttons, a restored design and a
     ?width= link all stop at the design's own maximum width (tnf-cat-sizes
     1.4.0 limits(): whole cm in AU, whole inches rounded down in the US,
     never over 94 in); a design twice as tall as wide stops at 120 x 240.
   TNF CATALOGUE product page controller 1.9.0                   2026-09-25
   1.9.0 (completion brief 2, 25 Sep 2026):
   - PACKING = the creator's approach, ONE plan. The size note, the summary
     row, the order line's 'Supplied In' and (in the order service) the
     carton price and the factory record all come from tnf-cat-geometry
     1.2.0 catalogueParts(board W, board H): one piece within 110 cm; TWO
     sections when it needs splitting, its longest side is under 150 cm and
     each half fits the 120 cm machine limit; otherwise made in sections.
     The customer reads the creator's own words. 1.8.x's width-only rule
     (two parts over 110 cm wide, multiple over 220 cm) is withdrawn.
   - THE PLUG SELECTED IS THE PLUG ORDERED. No plug source is written and the
     View design link always carries the plug (_tnf_cfg ... plug=...).
   - NO "AS PICTURED". A fixed design's Neon Colour is its production colours
     (tnf-cat-mfg-1-1-0.js: the manufacturing records, else the product photo
     review); Backboard Colour is Clear or UV Print from the same file. A
     fixed design without a colour record cannot be bought (never guessed).
   - No office checks: the hidden _tnf_check property and its source are gone.
   - Grade E (a manually corrected image trace, registry 1.5.0) is priced like
     A, B and R; the engine is tnf-pricing 2.6.8 (policy catalogue-2).
   1.8.1 (25 Sep 2026): the factory never gets a blank colour or backboard.
     84 past sheet rows of fixed-colour catalogue designs have no blank
     colour (75 list the colours, 4 say "same as image", 3 name the design,
     2 say RGB), so a fixed design with no recorded colours now sends
     Neon Colour "As pictured",
     and a design whose filled areas may be printed sends Backboard Colour
     "As pictured" (the page's own words) - never "Clear", never blank. The
     hidden office check (_tnf_check) stays and says so. Prices unchanged.
   1.8.0 also carries 1.7.1 (25 Sep 2026): every price the page renders is
     published as the 'tnf:price' event (and window.__tnfCatPrice) - the
     amount the customer sees, after any promotion the page shows, or null
     while no price is shown - for the Afterpay message beneath the price
     (assets/tnf-afterpay-1-0-0.js). Nothing else changes.
   1.8.0 (master completion brief, 25 Sep 2026):
   - THE PARTS RULE beneath the size controls on every catalogue design, in the
     creator's note style: "Signs over 110 cm wide are supplied in two parts.
     Signs over 220 cm wide are supplied in multiple parts." (US: over 43 in /
     over 86 in - the whole inches past 110 cm and 220 cm.) Decided on the EXACT
     width: 110 cm is one piece, 111 cm two parts, 220 cm two parts, 221 cm
     multiple; 43 in (109.22 cm) one piece, 44 in two parts, 86 in two parts,
     87 in multiple. The sentence that applies to the chosen width is
     highlighted and switches at those boundaries. The summary says so
     ("Supplied in two parts") and the order line carries 'Supplied In' (a
     key the live sheet parser does not read - no column changes). No count
     of parts is ever promised above 220 cm.
   - ONE ELIGIBILITY RULE for a price, the same on the page, the cards and the
     order service: a tube length with evidence grade A, B or R (registry 1.4.0:
     image-derived estimates, never called manufacturer-verified) or M (a
     manufacturer-stated length stored on the product)
     measured at THIS product's current reference record (the size model's
     ref: same name, width and height). A length measured at any other
     reference is not relabelled - the design waits for a price instead. The
     size controls always follow the size model's reference.
   - THE PLUG IS PROVISIONAL UNTIL CHOSEN. The adapter pre-selected from the
     store the customer is browsing is only a default - the domain, currency
     and browsing location say nothing about where the sign will be used. The
     order line now says which it is (hidden '_tnf_plug_source': 'chosen' once
     the customer picks an adapter, else 'default'), so the delivery address
     can settle a default after checkout while an explicit choice is kept.
     'View design' links carry the plug only when it was chosen.
   - Engine tnf-pricing-2-6-7.js with geometry adapter 1.1.0 (catalogue
     hardware policy: dimmer at exactly 5 m, outdoor above 12 m, uncapped
     sections, UV-printed artwork costed at the matrix UV print rate) - those
     configurations are priced, and say what was assumed in the order's
     manufacturing record, not to the customer.
   - THE BACKBOARD FOR THE FACTORY (column G): 'UV Print' where the
     manufacturing records say so OR the registry's review saw printed
     artwork (production.uvPrint); where the review could not tell printed
     areas from glow (production.backboardToConfirm) no backboard colour is
     sent and the hidden '_tnf_check' asks the office to confirm it - never a
     silent 'Clear'. A fixed design with no recorded production colours says
     so in '_tnf_check' too (the colour cell is left for a person to fill, not
     silently).
   1.7.0 (overnight brief - the order line, traced to the factory sheet): the
     order properties follow what the live Paid -> Cindy parser (Zap v39,
     read 24 Sep) actually reads: 'Neon Colour' (the colour chosen; a fixed
     colour; a fixed design's RECORDED production colours from
     tnf-cat-mfg-1-0-0.js, never a default), 'Wall Mounting Kit' = the finish
     (the parser writes it verbatim into the wall-mounting column), the wall
     kit's own token in 'Additional Options', UV-printed backboards where the
     manufacturing records say so, and two hidden keys (_tnf_design, _tnf_cfg)
     for the cart's "View design" link. The order service (catalogue module)
     derives the same properties server-side; the cart adds ITS copy. A link
     back from the cart restores the configuration (?w, colour, use, wall,
     hang, tape, dimmer, battery, plug). Add to cart keeps the creator's
     protection against a second add after a lost response.
   1.6.2 (Jack, 24 Sep 2026)
   1.6.2: while the width box has focus (the customer is typing a width) the
     purchase bar steps aside (html.tnf-cat-typing), so it can never cover the
     box - the pinned price tag still shows the price of the width typed.
   1.6.1: the minimum and the proportions of EVERY catalogue product come from
     the shared size model (tnf-cat-sizes-1-0-0.js; 1.1.0 since page 1.8.0) reading the product's own
     offered size records - resolving formatting and rounding differences,
     isolating a record that truly contradicts itself - so no product loses
     its size controls to one bad record, a missing tube length or pricing.
   1.6.0 (Jack, 24 Sep 2026 - continuous size selection and pricing):
   - NO standard-size buttons and NO standard-size pricing. Every catalogue
     design - selectable, fixed single-colour, fixed multicolour - offers its
     width through the slider, the number box and - / +, every 1 cm (AU) /
     1 inch (US) from its own minimum to 240 cm / 94 in; the height follows
     the proportions of its sound size record.
   - Every width is priced by the catalogue engine (the design's measured
     tubing, the approved geometry adapter and the AU/US retail table) - the
     price in the summary, the picture tag, the head of the panel and the
     purchase bar is the engine price of exactly the chosen width, use and
     extras. The TODAY'S PRICES mode of 1.4.0/1.5.0 (variant prices at the
     four standard sizes, "Ask us for a price" at any other width) is gone.
   - Add to cart is enabled ONLY when a purchase path that can charge that
     price is connected (tnf-launch-config service=URL -> the order service's
     catalogue module). Without it the price still shows, Add to cart stays
     disabled and says so, and the quote request carries the configuration
     and the price shown. A design without complete pricing inputs keeps
     every control and reads "Price to be confirmed".
   - The minimum is the smallest offered size whose WIDTH record is sound and
     the proportions come from a fully sound size (CFG.sizeResolved, buy box
     1.7.0), so one unsound size no longer removes the size control.
   1.5.0 (final brief: "Minimum means the smallest verified offered size"):
   - TODAY'S PRICES per size: every offered size carries its own verification
     (CFG.offered[].ok, tnf-size-record 1.1.0). Only verified sizes are sold
     and shown with a measurement. A design whose record is unsound at SOME
     size (69 designs) no longer loses every size and price: it opens at its
     smallest verified size (the size its card prices) and offers its
     verified sizes as one-tap choices (withdrawn in 1.6.0 - no free width, because its
     record cannot vouch for a height at any other width); the unverified
     sizes are named as confirmed with the quote. No record is repaired or
     guessed here.
   1.4.0 (Jack, 24 Sep 2026 - final implementation and launch brief):
   - EVERY catalogue design pins its picture on phones and tablets, whatever
     its colour type, pricing readiness or tube measurement: the 1.3.0 rule
     that left an unmeasured photo unpinned is gone. Every catalogue photo now
     has framing data (tnf-cat-focus 2.0.0, all 877 designs), and a photo that
     still has none is framed WHOLE (CROP.SAFE): pinned like every other
     photo, its compact window simply never shorter than the full picture, so
     nothing can be cut. Framing is not pricing: no tube length is read here.
   - customer-facing copy no longer explains internal pricing inputs (tube
     measurement, estimation, stored size records): a design that is still
     being priced reads "Price to be confirmed" with a plain quote route.
   - TODAY'S PRICES (variant-backed): until a design's engine price can be
     charged (complete inputs AND the order service connected - CFG.engineLive),
     the page prices what the product already sells: its standard sizes
     (CFG.offered - each size's own dimension record and its live variant, in
     this market's currency) at that variant's own price, indoor, with the
     included extras. The page still opens at the verified minimum size, so it
     shows exactly the price the card shows, and Add to cart puts that real
     variant in the cart with the existing order properties ("Sign Size" is the
     size's own record, verbatim, as on every past order). Any other size,
     outdoor use or a paid extra reads "Price to be confirmed" with the quote
     route - no price is estimated, interpolated or borrowed. The standard
     sizes are offered as one-tap choices under the width.
   1.2.0 (Jack, 24 Sep 2026 - Brief 6):
   - the pinned mobile picture is ALWAYS the selected colour's ORIGINAL product
     photograph: the full, compact, typing and expanded states show the same
     file, seen through a taller or shorter window (CROP). The creator-room +
     extracted-sign compositing of 1.1.2 is gone from the customer's path. The
     window is positioned from where the sign sits in THAT photo (TNF_CAT_FOCUS,
     measured once from the original render; no pixel is altered), and the
     compact height is whatever that sign needs - a tall design gets a taller
     strip, never a chopped sign. The picture shrinks WITH the scroll (the
     thumbnails stay right under it: no blank band), price top-left, size
     bottom-left, Expand bottom-right, none of them over the design: the sign
     is described by its box AND a 16-column profile of the lit tube (so a
     chip beside a narrow part of the sign does not count as over it), the
     chips by their real pill shapes, and the few designs whose sign sits in
     the photo's top corner under the price (three at phone widths) get one
     uniformly closer crop per photo (same photo, never stretched or
     letterboxed, constant while the page scrolls).
   - the power adapter step is the creator's: label and the four countries,
     no explanatory note under it in any state; it stays usable on designs
     priced by hand and travels into the quote request.
   - the page OPENS AT THE PRODUCT'S VERIFIED MINIMUM SIZE (its smallest
     offered size; AU whole cm, US the physical minimum rounded UP to a whole
     inch) and prices exactly that configuration with only the included
     options - the same configuration the product card prices. A customer's
     own adjustment is kept while they stay on the product.
   - a promotion that ends (or stops applying) while the page is open puts the
     regular price back everywhere at once (refresh, not just a class).
   - a thumbnail of a colour's photo selects that colour, and a colour
     selection highlights its thumbnail, so picture, thumbnails and summary
     always agree.
   1.1.2: desktop gallery clearance measured live from the header that is
   actually stuck (scroll / resize / zoom), so the sticky picture - price chip
   included - never slides under the theme's late-appearing sticky header;
   pinned compact stage on phones = creator room + prepared sign layer (SIGN);
   power adapter step (the creator's plug select) writing the existing
   "Power Adapter" order property in the catalogue's accepted values.
   1.1.1: a colour selection with no image of its own also cancels a pending image load.
   1.1.0 (Jack, 23 Sep 2026): maximum width 240 cm / 94 in for every valid
   design (DESIGN.maxWidth_mm, delivered by the buy box); the 12V battery
   pack orderable with the working creator's rule (dimmer or battery, at least
   one) and its own token in the existing "Additional Options" list; a chosen
   colour shows that colour's own variant image (CFG.colourMedia, mapped
   explicitly, latest selection always wins over an older image load); the
   price sits top-left and the size bottom-left of the picture; on phones and
   tablets the picture pins at the top while the options scroll (PIN below).
   --------------------------------------------------------------------------
   Pinned, read-only dependencies (never modified, never version-floated;
   loaded by snippets/tnf-catalogue-buybox.liquid 1.9.0):
     tnf-pricing-2-6-7.js        the creator's pricing engine + the opt-in
                                 catalogue hardware policy (2.6.6 unchanged
                                 for any geometry without it - the creator)
     tnf-cat-geometry-1-1-0.js   catalogue geometry adapter (this workstream)
     tnf-cat-registry-1-4-0.js   measured tube lengths (grades A/B/R)
     tnf-cat-sizes-1-1-0.js      shared size model (with the reviewed
                                 W/H swaps and height corrections)
     tnf-creator-2-5-10.css      the creator's design system

   WHAT CHARGES THE CUSTOMER
   The price on screen is a DISPLAY of the engine's quote. It is never what
   is submitted. Adding to cart always resolves a real Shopify variant whose
   own price is the charge, through one of two sources:

     source "variants"  a pre-created variant per (width, use) with a real
                        AUD price and a fixed USD price on the USA price
                        list. Authoritative with no backend.
     source "service"   the creator's order service contract - POST /quote
                        for a signed re-price, then POST /order for a
                        variant id. Identical contract to the creator, so
                        one service can serve both.

   Before anything is added, the resolved variant's OWN price is compared
   with the quote. If they disagree, or no source is configured, NOTHING is
   added and the customer is told. A stale or failed price can never become
   an order. There is no path in this file that sends a price to Shopify.
   ========================================================================== */
(function () {
  'use strict';
  var MM_IN = 25.4;
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var root = document.getElementById('tnf-cat');
  if (!root) return;

  var CFG     = window.TNF_CAT_CONFIG || {};
  var DESIGN  = (window.TNF_CAT_DESIGNS || {})[CFG.handle] || null;
  /* 1.3.0 (Jack, 24 Sep 2026 - Brief 7): COLOUR MODE AND PRICING READINESS ARE SEPARATE. Every catalogue
     product - selectable colours, one fixed colour or its own multicolour artwork - gets the same
     configuration page (size, Indoor/Outdoor, backboard, mounting, power adapter, accessories, preview,
     summary, purchase controls; a fixed-colour design simply has no colour picker). A missing pricing input
     takes away only what depends on it:
       size_record     the product's own size record is missing or contradicts itself: no size control (a
                       width and height would be a guess) and no price; every other option stays
       no_tube_length  no measured tube length: every control works and the preview follows the chosen
                       size; the price is "to be confirmed"
     Nothing is estimated and no fallback price is shown. Add to cart stays on the (not yet connected)
     purchase service and is disabled until the design is priced; the quote request carries the whole
     configuration. (1.2.x showed a stripped "Priced by hand for now" box instead.)
     1.3.1: the pending summary follows a change of power adapter, and a gallery photo of a colour selects
     that colour, exactly as on a priced design.
     1.3.2: amounts are thousands-separated like the card badge (A$4,477, not A$4477). */
  /* 1.6.1 (Jack, 24 Sep 2026): the SHARED size model (tnf-cat-sizes-1-0-0.js) sets the minimum and the proportions
     for every catalogue product from its own offered size records - the same function the order service and the
     catalogue checks use. Tube length and pricing readiness play no part in it. */
  var MODEL = (window.TNF_CAT_SIZES && CFG.sizeRecords) ? window.TNF_CAT_SIZES.resolve(CFG.handle, CFG.sizeRecords) : null;
  if (DESIGN && MODEL && MODEL.ok) {
    CFG.minWidth_cm = MODEL.min_cm; CFG.minSizeName = MODEL.minName; CFG.sizeResolved = true; CFG.refSizeName = MODEL.ref.name;
    DESIGN.minWidth_mm = MODEL.min_cm * 10;
    /* 1.8.0: the tube length is priced only at the reference it was measured at. Record that reference, then let the
       size model's reference drive the size controls (for a tied design the two are the same numbers). */
    /* the registry (1.4.0 put()) or the product's own metafields name the reference the length was measured at */
    if (DESIGN.tubing_m_at_ref > 0) CFG.measuredRef = { name: DESIGN.measuredRefName || null, w: Number(DESIGN.measuredRefWidth_mm) || 0, h: Number(DESIGN.measuredRefHeight_mm) || 0 };
    /* 1.10.0: a grade P design's cost-model estimate belongs to a reference too (never relabelled) */
    else if (hasRecords(DESIGN)) CFG.measuredRef = { name: DESIGN.costModelRefName || null, w: Number(DESIGN.costModelRefWidth_mm) || 0, h: Number(DESIGN.costModelRefHeight_mm) || 0 };
    DESIGN.refWidth_mm = MODEL.ref.w_cm * 10; DESIGN.refHeight_mm = MODEL.ref.h_cm * 10; DESIGN.mediumWidth_mm = DESIGN.refWidth_mm;
    if (!(DESIGN.refInkHeight_mm > 0) || !(DESIGN.tubing_m_at_ref > 0 || hasRecords(DESIGN))) DESIGN.refInkHeight_mm = DESIGN.refHeight_mm / 1.22;
  } else if (DESIGN && MODEL && !MODEL.ok) { CFG.sizeResolved = false; CFG.minIssue = MODEL.why || CFG.minIssue; }
  function gradeOk(d) { var g = d && d.evidence && d.evidence.grade; return g === 'A' || g === 'B' || g === 'R' || g === 'E' || g === 'M' || (g === 'P' && hasRecords(d)); }
  /* 1.10.0: a grade P design (priced from its size records) - the geometry adapter's own definition */
  function hasRecords(d) { return !!(d && window.TNF_CAT_GEOM && typeof window.TNF_CAT_GEOM.isRecords === 'function' && window.TNF_CAT_GEOM.isRecords(d)); }
  /* 1.10.0: the 240 cm limit for this design in a market (null when the size model has no limits) */
  function limitsFor(market) {
    if (!MODEL || !MODEL.ok || !window.TNF_CAT_SIZES || typeof window.TNF_CAT_SIZES.limits !== 'function') return null;
    return window.TNF_CAT_SIZES.limits(MODEL, market === 'US' ? 'US' : 'AU');   /* the UK uses the AU (centimetre) grid */
  }
  /* 1.10.0: grade P records open at the product's own smallest size in both markets (as order module 1.4.0) */
  function recordsOpenOk(d) {
    var p = d && d.pricing, m = MODEL && MODEL.ok ? MODEL.min_cm * 10 : null;
    return !!(p && m != null && p.AU && p.US && Math.abs(p.AU[0][0] - m) <= 1e-6 && Math.abs(p.US[0][0] - m) <= 1e-6);
  }
  function refTied() {
    var m = CFG.measuredRef; if (!m || !(m.w > 0) || !(m.h > 0) || !MODEL || !MODEL.ok) return false;
    return (!m.name || m.name === MODEL.ref.name) && Math.abs(m.w - MODEL.ref.w_cm * 10) <= 0.5 && Math.abs(m.h - MODEL.ref.h_cm * 10) <= 0.5;
  }
  var READY = (function () {
    var r = { price: true, size: true, code: '', detail: '' };
    if (!DESIGN) return r;
    if (CFG.sizeResolved === false) { r.size = r.price = false; r.code = 'size_record'; r.detail = (CFG.minIssue || '') + ' ' + (CFG.dimIssue || ''); }
    else if (CFG.sizeResolved === undefined && CFG.minResolved === false) { r.size = r.price = false; r.code = 'size_record'; r.detail = CFG.minIssue || ''; }
    else if (CFG.sizeResolved === undefined && CFG.dimRecordOk === false) { r.size = r.price = false; r.code = 'size_record'; r.detail = CFG.dimIssue || ''; }
    else if (!(DESIGN.refWidth_mm > 0 && DESIGN.refHeight_mm > 0 && CFG.minWidth_cm > 0)) { r.size = r.price = false; r.code = 'size_record'; r.detail = 'no reference size'; }
    /* 1.10.0: no valid size under the 240 cm limit (the smallest offered size is already taller) */
    else if (limitsFor('AU') && (!limitsFor('AU').ok || !limitsFor('US').ok)) { r.size = r.price = false; r.code = 'size_limit'; r.detail = limitsFor('AU').why || limitsFor('US').why || ''; }
    /* 1.10.0: grade P - priced from its size records */
    else if (DESIGN.evidence && DESIGN.evidence.grade === 'P') {
      if (!hasRecords(DESIGN)) { r.price = false; r.code = 'no_price_records'; r.detail = 'grade P design without complete size records'; }
      else if (!refTied()) { r.price = false; r.code = 'no_price_records'; r.detail = 'cost-model estimate made at a different reference size than the product record'; }
      else if (!recordsOpenOk(DESIGN)) { r.price = false; r.code = 'no_price_records'; r.detail = 'the size records no longer open at the product\'s smallest size'; }
    }
    else if (!(DESIGN.tubing_m_at_ref > 0)) { r.price = false; r.code = 'no_tube_length'; }
    /* 1.8.0: the single eligibility rule (see the header) */
    else if (!gradeOk(DESIGN)) { r.price = false; r.code = 'no_tube_length'; r.detail = 'tube length not graded for pricing'; }
    else if (!refTied()) { r.price = false; r.code = 'no_tube_length'; r.detail = 'tube length measured at a different reference size than the product record'; }
    return r;
  })();
  var COLOURS = CFG.colours || [];
  /* 1.7.0: what the factory has been told for this design (tnf-cat-mfg-1-0-0.js): recorded production colours of a
     fixed design and a UV-printed backboard - only where the manufacturing records agree */
  var MFG = (window.TNF_CAT_MFG || {})[CFG.handle] || {};
  var PROD = (DESIGN && DESIGN.production) || {};
  /* 1.9.0: the production record (tnf-cat-mfg-1-1-0.js) names the backboard of EVERY design: Clear, or UV Print for
     printed / infilled artwork. The registry's UV flag (which also prices the print) comes from the same decision. */
  if (MFG.backboard === 'Clear' || MFG.backboard === 'UV Print') CFG.backboardColour = MFG.backboard;
  else if (PROD.uvPrint) CFG.backboardColour = 'UV Print';
  function boardText() {
    var shape = CFG.signShape || 'Cut To Shape', bc = CFG.backboardColour || 'Clear';
    return shape + ', ' + (/^uv/i.test(bc) ? 'clear acrylic with UV-printed artwork' : bc.toLowerCase() + ' acrylic');
  }
  /* 1.9.0: a design made in its own colours is sold only with its colours on record (never "As pictured") */
  function fixedColoursMissing() {
    return CFG.colourMode !== 'selectable' && CFG.colourMode !== 'fixed-single' && !(MFG.colours && MFG.colours.length);
  }
  if (fixedColoursMissing() && READY.price) { READY.price = false; READY.code = 'colour_record'; READY.detail = 'no colour record for this fixed-colour design'; }
  /* 1.9.0: the colour words of the summary: the colour chosen, the design's one colour, or its production colours */
  function colourText() {
    if (CFG.colourMode === 'selectable') return S.colour || '';
    if (CFG.colourMode === 'fixed-single') return CFG.fixedColour || S.colour || '';
    return MFG.colours && MFG.colours.length ? MFG.colours.join(', ') : '';
  }
  $$('[data-tnf-fixedcols]').forEach(function (el) { el.textContent = colourText(); });
  var ORDER   = CFG.order || { source: 'none' };
  /* 1.6.0: a purchase path that can charge the engine price of ANY width - the order service's catalogue module
     (tnf-launch-config service=URL). Without one, prices show and Add to cart stays disabled (never a dead button). */
  var CAN_BUY = !!(ORDER.source === 'service' && ORDER.service);
  /* 1.11.0: Add to cart state (see addToCart) */
  var SVC_TIMEOUT = { quote: 15000, order: 45000, cart: 20000 };
  var ADDING = false, PREQ = null, PREQ_PENDING = null, PREQ_TIMER = null, T_ADD = null;
  function sizeOk() { return CFG.sizeResolved !== undefined ? CFG.sizeResolved !== false : (CFG.minResolved !== false && CFG.dimRecordOk !== false); }

  /* ---- explicit colour -> image overrides (tnf-cat-colour-media-1-0-0.js) --
     The Liquid map comes from the variants' own image links. Where a product's
     links are missing or two colours share one image, the reviewed mapping in
     window.TNF_CAT_COLOUR_MEDIA wins for the colours it lists; every other
     colour keeps its variant link. Nothing is guessed at run time. */
  CFG.colourMediaOverride = [];
  (function () {
    var ov = (window.TNF_CAT_COLOUR_MEDIA || {})[CFG.handle];
    if (!ov) return;
    CFG.colourMedia = CFG.colourMedia || {};
    Object.keys(ov).forEach(function (name) {
      if (ov[name] && ov[name].src) { CFG.colourMedia[name] = ov[name]; CFG.colourMediaOverride.push(name); }
    });
  })();

  /* ---- market, exactly as the creator resolves it ---------------------- */
  function market() {
    try {
      var c = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.currency;
      if (c === 'USD') return 'US';
      if (c === 'AUD') return 'AU';
      if (c === 'GBP') return 'UK';   /* 1.13.0: the UK storefront */
    } catch (e) {}
    if (/theneonfactory\.co\.uk$/.test(location.hostname)) return 'UK';
    return /theneonfactory\.com$/.test(location.hostname) ? 'US' : 'AU';
  }

  var S = {
    market: market(),
    width_mm: 0,
    outdoor: false,
    /* selectable: first offered colour; fixed-single: the product's one
       colour; fixed-design: '' - the sign is made in its own colours as
       pictured and no colour is chosen or recorded (as on every past order) */
    colour: CFG.colourMode === 'selectable' ? ((COLOURS[0] || {}).name || '') : (CFG.fixedColour || ''),
    /* power adapter: the creator's rule - the market's plug unless the customer picks another (1.1.2) */
    plug: market() === 'US' ? 'USA / CANADA' : market() === 'UK' ? 'UK / IRELAND' : 'AUSTRALIA / NZ',
    wallMount: false, wallFinish: 'silver',
    hanging: false, tape: false,
    dimmer: true, battery: false,
    qty: 1,
    widthTouched: false,
    unpriced: false
  };

  function unit()    { return S.market === 'US' ? 'in' : 'cm'; }
  /* 1.14.0 (2 Oct 2026, UK launch, preview): UK-only quote-required handling for the 43 grade P designs. Their price
     comes from recorded AU/US selling prices that do not give a reliable UK cost (UK launch review v2, section 3), so
     in the UK the page keeps every option, shows no price, disables Add to cart and offers the quote route - the
     same "price to be confirmed" presentation AU/US already use. Engine 2.7.1 refuses the same designs for the UK
     (uk_quote_required_cost_unverified), so the order service cannot be asked for a UK price either. AU/US unchanged. */
  if (S.market === 'UK' && READY.price && DESIGN && DESIGN.evidence && DESIGN.evidence.grade === 'P') {
    READY.price = false; READY.code = 'uk_quote_required'; READY.detail = 'UK: grade P design - priced by quote in the UK';
  }
  /* 1.14.0: UK option labels from engine 2.7.1's UK table (the table the quote charges); AU/US labels untouched */
  function ukLabels() {
    if (S.market !== 'UK' || !window.TNF_PRICE || typeof window.TNF_PRICE.fixedPrices !== 'function') return;
    var F = window.TNF_PRICE.fixedPrices('UK'), lab = function (n) { return n > 0 ? '+' + F.symbol + n : 'Free'; };
    [['#tnf-cat-hang', F.accessories.hanging_kit], ['#tnf-cat-tape', F.accessories.tape_3m], ['#tnf-cat-battery', F.accessories.battery_pack]].forEach(function (p) {
      var inp = $(p[0]), c = inp && inp.closest('.tnf-acc-ctl'), t = c && c.querySelector('.tnf-acc-p'); if (t) t.textContent = lab(p[1]); });
    $$('#tnf-cat-wallfin .tnf-wf').forEach(function (b) { var t = b.querySelector('.tnf-wf-p'), v = F.wallMountKit[b.getAttribute('data-wf')]; if (t && v != null) t.textContent = lab(v); });
  }
  function step_mm() { return S.market === 'US' ? MM_IN : 10; }
  function toDisp(mm){ return S.market === 'US' ? mm / MM_IN : mm / 10; }
  function fromDisp(v){ return S.market === 'US' ? v * MM_IN : v * 10; }
  function snap(mm)  { var s = step_mm(); return Math.round(mm / s) * s; }
  function cur()     { return S.market === 'US' ? 'US$' : S.market === 'UK' ? '\u00a3' : 'A$'; }
  /* 1.13.0: the small prefix and the large symbol of a split price ("A" + "$", "US" + "$", "" + "£") */
  function curPre()  { return S.market === 'UK' ? '' : cur().replace('$', ''); }
  function curSym()  { return S.market === 'UK' ? '\u00a3' : '$'; }

  /* Bounds are one physical geometry in mm, snapped INWARD to this market's
     step so a displayed value always represents a buildable width.

     THE MINIMUM IS PRODUCT-SPECIFIC (Jack, 2026-09-21): it is this product's
     smallest size option actually offered on the website, resolved in Liquid
     from that option's own dimension metafield and delivered as
     CFG.minWidth_cm. There is no universal minimum and no fallback - if the
     product's own data did not resolve, minResolved is false and build()
     refuses to render the control at all.

     Rounding direction matters and is deliberate:
       AU  1 cm steps  - ceil, so the slider never sits below the physical limit
       US  1 in steps  - ceil on the EXACT conversion, so a 50 cm physical
                         minimum becomes 20 in (= 50.80 cm), never 19 in
                         (= 48.26 cm) which is smaller than the sign is made.
     The extra 0.8 cm is real: it is priced and manufactured at 50.8 cm, never
     labelled as 50 cm. */
  /* ======================================================================
     MANUFACTURING PRECISION - declared once, applied to BOTH axes, BEFORE
     pricing. Jack, 2026-09-21.

     The previous build priced an exact value and then rounded the factory
     payload to whole centimetres afterwards, so the price and the
     manufacturing instruction described different signs:
         US 25 in  priced 635.0 mm, factory told 64 cm   -> +5.0 mm
         US 23 in  priced 584.2 mm, factory told 58 cm   -> -4.2 mm (smaller than paid for)
         AU 50 cm  priced 135.714 mm tall, factory told 14 cm -> +4.29 mm
     Australia was NOT exempt: its width grid is already whole centimetres,
     but its HEIGHT is derived and was rounded the same way.

     0.1 cm (1 mm) is the precision the existing path already carries:
     92 stored dimension strings across 35 products hold a decimal, and
     orders #TNF1633, #TNF1725 and #TNF1766 each recorded "45X40.8" on the
     order. The field is single_line_text_field, and Cindy's column F is free
     text that already carries "1.2m x 1.2m" and, written today by the
     creator, "Width: 18cmxHeight: 14cm".

     WIDTH: the customer's selection, kept EXACT. Australia selects whole
     centimetres. The USA selects whole inches, and a whole inch is exactly
     2.54 cm, so the factory record carries the exact conversion: 20 in is
     50.8 cm (never 51), 13 in is 33.02 cm (never 33 or 33.1). At most two
     decimals, and two only when the inch count is not a multiple of five.
     Verified on the storefront 2026-09-23: rounding the width to the 1 mm
     grid had been turning 13 in into 33.1 cm and 67 in into 170.2 cm, which
     is the same silent substitution at a smaller scale, so the width no
     longer touches the grid at all.

     HEIGHT: derived from the width by the design's own aspect ratio, and
     quantised ONCE to 1 mm here. That quantised height - not the raw
     ratio - is what the engine prices (it travels in quoteCfg.height_mm and
     tnf-cat-geometry 1.0.1 uses it as the board height), what the preview
     shows, and what the factory record says. */
  var MFG_MM = 1;                                   /* 0.1 cm grid for the DERIVED height */
  function mfg(mm)      { return Math.round(mm / MFG_MM) * MFG_MM; }
  /* cm with at most two decimals, trailing zeros dropped so whole sizes read
     exactly as they do today ("70x19", not "70x19.0"); 508 mm -> "50.8",
     330.2 mm -> "33.02". */
  function cmStr(mm)    { var v = mm / 10; return (Math.round(v * 100) / 100).toString(); }

  function minPhysical_mm() {
    var cm = Number(CFG.minWidth_cm);
    if (isFinite(cm) && cm > 0) return cm * 10;
    return DESIGN.minWidth_mm;            /* registry-only preview products */
  }
  /* Bounds are exact multiples of this market's step: the physical minimum
     rounded UP to the next whole cm / inch, the maximum rounded DOWN. */
  function minW() { var s = step_mm(); return Math.ceil(minPhysical_mm() / s - 1e-9) * s; }
  /* 1.1.0: DESIGN.maxWidth_mm is the catalogue cap, 2400 mm, for every valid design
     (Jack, 23 Sep 2026). AU: 240 cm. US: floor(2400 / 25.4) = 94 in = 2387.6 mm; 95 in
     would exceed the cap. The label reads "94 in", the factory record 238.76 cm - never 240. */
  /* 1.10.0: and neither side over 240 cm - the design's own maximum width (tnf-cat-sizes 1.4.0 limits()) */
  function maxW() {
    var s = step_mm(), cap = Math.floor(DESIGN.maxWidth_mm / s + 1e-9) * s, L = limitsFor(S.market);
    return L && L.ok ? Math.min(cap, L.max_mm) : cap;
  }

  /* ---- pricing --------------------------------------------------------- */
  function quoteCfg() {
    return {
      market: S.market, handle: CFG.handle, width_mm: S.width_mm, height_mm: height_mm(), outdoor: S.outdoor,
      /* the engine's cost base is per metre of tube whatever the colour, so
         every catalogue design prices as 'single'; the product's colour
         behaviour travels alongside for the order record */
      colourMode: 'single', colourName: S.colour, colourBehaviour: CFG.colourMode || 'selectable',
      finish: 'clear', backboard: DESIGN.boardStyle || 'cut_to_shape',
      wallMountingKit: S.wallMount, wallMountFinish: S.wallFinish,
      hangingKit: S.hanging, tape3m: S.tape,
      freeDimmer: S.dimmer, batteryPack: S.battery,
      plug: S.plug,
      quantity: S.qty
    };
  }
  /* CATALOGUE retail multipliers. Approved by Jack, 18 Sep 2026, for the
     CATALOGUE only. They are applied by swapping the engine's retail table
     for the duration of one quote call and restoring it immediately, so the
     creator's own rates (AU 4.5/5, US 2.5/3) are never persistently changed
     even if both surfaces are ever loaded on the same page. */
  /* Jack's instructed matrix, brief of 2026-09-16, reaffirmed 2026-09-19:
       Australia  indoor x4.5   outdoor x5
       USA        indoor x2.5   outdoor x3
     Applied directly to the USD manufacturer cost to give the selling price in
     the market's own currency. No FX conversion anywhere on this path.
     Fixed accessories are added afterwards, once, by the engine.
     NOTE: this is the CATALOGUE configuration only. The creator's own rates in
     tnf-pricing-2-6-2.js are swapped in and restored around every call and are
     never persistently changed. */
  var CAT_RETAIL = (CFG.retail) || { AU: { indoor: 4.5, outdoor: 5 },
                                     US: { indoor: 2.5, outdoor: 3 },
                                     /* 1.13.0: the UK, read from the engine (2.7.0) so page and engine cannot disagree */
                                     UK: (window.TNF_PRICE && window.TNF_PRICE.RATES.retail.UK) || { indoor: 2.4, outdoor: 2.8 } };
  if (!CAT_RETAIL.UK) CAT_RETAIL.UK = (window.TNF_PRICE && window.TNF_PRICE.RATES.retail.UK) || { indoor: 2.4, outdoor: 2.8 };
  function quote() {
    /* 1.3.0: a product that cannot be priced yet answers with the reason, never with a number */
    if (!READY.price) return { ok: false, blocking: [READY.code], market: S.market, readiness: true, addOns: { items: [] } };
    if (!window.TNF_PRICE || !window.TNF_CAT_GEOM) return null;
    if (!sizeOk()) return null;
    /* no measured tubing = no price. The tubing length is the manufacturer
       cost driver, and it is never estimated from the outline. */
    if (!DESIGN || !(DESIGN.tubing_m_at_ref > 0 || hasRecords(DESIGN))) return null;
    /* A sound width minimum does NOT make an unresolved height record
       quotable. The registry is not allowed to rescue a product whose own
       record contradicts itself - that would be silently choosing another
       source for a value that is in dispute. */
    if (!sizeOk()) return null;
    var prevGeom = window.TNF_GEOM, prevRates = window.TNF_PRICE.RATES.retail;
    window.TNF_GEOM = window.TNF_CAT_GEOM;
    window.TNF_PRICE.RATES.retail = CAT_RETAIL;
    try { return window.TNF_PRICE.quote(quoteCfg()); }
    finally { window.TNF_GEOM = prevGeom; window.TNF_PRICE.RATES.retail = prevRates; }
  }

  /* ---- height + dimension strings -------------------------------------- */
  /* Quantised on the SAME grid as the width, and derived from the already
     quantised width, so the pair the customer is priced for is the exact pair
     the factory is told to build. */
  function height_mm() { return mfg(DESIGN.refHeight_mm * (S.width_mm / DESIGN.refWidth_mm)); }

  /* Customer-facing label in THIS market's unit. Rounded for reading only -
     the manufactured size always comes from width_mm / height_mm. */
  function dimsLabel() {
    if (!READY.size) return '';
    var w = toDisp(S.width_mm), h = toDisp(height_mm());
    if (S.market === 'US') return (Math.round(w)) + ' x ' + (Math.round(h * 2) / 2) + ' in';
    return Math.round(w) + ' x ' + Math.round(h) + ' cm';
  }
  /* The factory record is ALWAYS centimetres, both markets - unchanged from
     the existing order workflow (Sign Size "WxH"). */
  /* ALWAYS centimetres, both markets, same field, same structure - unchanged.
     The only change is that it now prints the canonical value rather than a
     second rounding of it, so a US 20 in sign records 50.8, not 51. Whole
     values are unchanged: an AU 70 cm sign still records "70x19". */
  function factorySize() {
    /* 1.4.0 TODAY'S PRICES: a standard size is made to its own record, sent verbatim exactly as on every past order */
    return cmStr(S.width_mm) + 'x' + cmStr(height_mm());
  }
  /* 1.12.0: the customer's one size line on the order line - the order module 1.6.0 rule, character for character:
     US whole inches wide x height to the half inch, AU the factory's centimetres with the unit */
  function lineSize() {
    if (S.market === 'US') return Math.round(S.width_mm / 25.4) + ' \u00d7 ' + (Math.round(height_mm() / 25.4 * 2) / 2) + ' in';
    return cmStr(S.width_mm) + ' \u00d7 ' + cmStr(height_mm()) + ' cm';
  }
  function fmtCm(v) { return String(Math.round(Number(v) * 10) / 10); }
  /* 1.9.0: THE packing plan - tnf-cat-geometry 1.2.0 catalogueParts on the exact board (the width and the quantised
     height the engine prices), so the note, the summary, the order line and the carton price cannot disagree. */
  function partsPlan() {
    if (!READY.size || !window.TNF_CAT_GEOM || typeof window.TNF_CAT_GEOM.catalogueParts !== 'function') return null;
    return window.TNF_CAT_GEOM.catalogueParts(S.width_mm, height_mm());
  }
  var SUPPLIED_IN = { two: 'Two sections, packed together in one package', sections: 'Sections' };
  function partsLine() {
    var p = partsPlan();
    return p && p.divided ? { key: p.key, notice: p.notice, line: p.line, supplied: SUPPLIED_IN[p.key] } : null;
  }
  /* the note under the size: the creator's words, only while the sign is made in more than one piece. It keeps its
     place (visibility, not display), so a change of wording never moves the slider. */
  function syncParts() {
    var n = $('#tnf-cat-partsnote'); if (!n) return;
    var pl = partsLine(), txt = pl ? pl.notice : '';
    if (n.textContent !== txt) n.textContent = txt;
    n.setAttribute('data-current', pl ? pl.key : 'one');
    n.classList.toggle('is-empty', !pl);
    n.setAttribute('aria-hidden', pl ? 'false' : 'true');
  }
  function altLabel() {
    return '';                        /* 1.12.1: US shows inches only; AU shows centimetres only (no second unit) */
  }
  /* 20 in is 50.8 cm exactly. The page says 20 in, the factory record says
     50.8, and both describe 508 mm. Nothing is silently converted. */

  /* ---- line item properties: the EXISTING catalogue contract ------------
     Keys and formats are unchanged from live orders so the Shopify ->
     Zapier -> Sheets flow keeps working. "Additional Options" stays the
     wire key even though the heading now reads "Mounting Options". */
  /* ACCESSORY TOKENS - copied VERBATIM from real paid orders, 2026-09-19.
     Evidence: 14 catalogue orders Mar-Sep 2026 carry exactly two distinct
     values of this key, plus #TNF1825 (21 Sep) with the tape token -
       "Free Remote And Dimmer, Free Wall Mounting Kit"
         (#TNF1789 1790 1794 1803 1809 1810 1817 1818 1819)
       "Free Remote And Dimmer, Free Wall Mounting Kit, Neon Sign Hanging Wire Kit"
         (#TNF1788 1806 1811 1814 1815)
     Cindy's Paid sheet columns J (Hanging wire kit) / K (Wall mounting) /
     L (3M Tape) are derived from this one string by the live Zaps
     (AU Paid->Cindy v37, US Paid->Cindy v18), so the strings and their order
     must not be reworded or re-ordered here. Verified against #TNF1819:
     "Free Remote And Dimmer, Free Wall Mounting Kit" -> J=No K=Yes L=No. */
  var ACC = {
    dimmer: 'Free Remote And Dimmer',
    wall:   'Free Wall Mounting Kit',
    hang:   'Neon Sign Hanging Wire Kit',
    /* CONFIRMED 2026-09-23 from a live catalogue order: #TNF1825 (21 Sep,
       Live Music Notes) carried "Free Remote And Dimmer, Free Wall Mounting
       Kit, 3M Double Sided Sticky Tape" and the AU Paid sheet (Sept tab,
       row 4) shows J=No K=Yes L=Yes - so the live parser recognises THIS
       string. The earlier "3M Double Sided Tape" (the Quotes-sheet heading)
       had no live precedent and is withdrawn. */
    tape:   '3M Double Sided Sticky Tape',
    /* 12V battery pack: the token the creator's own formatter (tnf-legacy-format
       1.3.0+) writes into the same mounting list - "12V Battery Pack" - so the
       fulfilment instruction reads identically for a catalogue sign. */
    battery: '12V Battery Pack'
  };
  /* ---- power adapter (1.1.2) ----------------------------------------------
     The creator's own list, verbatim (tnf-creator 2.5.10 PLUGS / tnf-legacy-format
     1.7.1 PLUGS). The order property is the catalogue's EXISTING "Power Adapter"
     field with the values its live product page (Mageworx option) already sends -
     Australia/NZ, Europe, UK/Ireland, USA/Canada - the first and last of which the
     Paid sheet Zap is confirmed to map to AU / US (report 07). Europe and UK/Ireland
     are accepted values of that same option; how the Zap writes them is PENDING
     an isolated test. */
  var PLUGS = ['AUSTRALIA / NZ', 'EUROPE', 'UK / IRELAND', 'USA / CANADA'];
  var PLUG_PROPERTY = { 'AUSTRALIA / NZ': 'Australia/NZ', 'EUROPE': 'Europe', 'UK / IRELAND': 'UK/Ireland', 'USA / CANADA': 'USA/Canada' };
  function plugDefault() { return S.market === 'US' ? 'USA / CANADA' : S.market === 'UK' ? 'UK / IRELAND' : 'AUSTRALIA / NZ'; }
  function plugProperty() { return PLUG_PROPERTY[S.plug] || PLUG_PROPERTY[plugDefault()]; }
  /* 1.2.0: exactly the creator's step - the label and the four countries, nothing written under the
     select in any state (the explanatory "Included with your sign ..." note is gone). What is supplied is
     unchanged: the chosen plug, included, in the existing Power Adapter token. */
  function syncPlug() {
    var sel = $('#tnf-cat-plug'); if (!sel) return;
    if (!sel.options.length) sel.innerHTML = PLUGS.map(function (p) { return '<option value="' + p + '">' + p + '</option>'; }).join('');
    if (sel.value !== S.plug) sel.value = S.plug;
    syncQuoteLink();
  }
  /* Designs priced by hand: the "Request a quote" link carries the product and the chosen plug into the
     site's existing enquiry form (/pages/contact, prefilled by tnf-enquiry-1-0-0.js). No price is stated or
     implied - the request says the price is to be confirmed. */
  function quoteHref(sizeOverride) {
    var q = new URLSearchParams();
    q.set('tnf_enquiry', '1');
    q.set('product', CFG.title || CFG.handle || '');
    q.set('handle', CFG.handle || '');
    q.set('adapter', plugProperty());
    if (CFG.colourMode === 'fixed-single' && CFG.fixedColour) q.set('colour', CFG.fixedColour);
    else if (CFG.colourMode === 'selectable' && S.colour) q.set('colour', S.colour);
    /* a priced design whose chosen configuration is quoted by hand (e.g. outdoor over 12 m): the size and use
       the customer chose go with it; a design priced by hand has no size control, so nothing is invented */
    /* 1.3.0: the whole configuration goes with it - size (when the design has a sound size record), use,
       backboard, mounting and extras - so nothing chosen on the page has to be typed again */
    if (sizeOverride) q.set('size', sizeOverride);
    else if (READY.size && S.width_mm > 0 && DESIGN && dimsLabel()) q.set('size', dimsLabel());
    /* 1.6.0: the price the page showed for exactly this configuration, so the reply can honour it */
    var lq = window.__tnfCatLastQuote; if (lq && lq.ok && lq.payable > 0) q.set('price', money(lq.payable));
    q.set('use', S.outdoor ? 'Outdoor' : 'Indoor');
    q.set('board', boardText() + ' backboard');
    try { var ex = mountingList(); if (ex.length) q.set('extras', ex.join(', ')); } catch (e) {}
    q.set('market', S.market);
    return '/pages/contact?' + q.toString();
  }
  function syncQuoteLink() {
    $$('#tnf-cat a[data-tnf-quote]').forEach(function (a) { a.setAttribute('href', quoteHref()); });
  }
  function mountingList() {
    var m = [];
    if (S.dimmer)    m.push(ACC.dimmer);
    if (S.wallMount) m.push(S.wallFinish === 'silver' ? ACC.wall : 'Wall Mounting Kit - ' + finishName());   /* 1.7.0: a paid finish says so */
    if (S.hanging)   m.push(ACC.hang);
    if (S.tape)      m.push(ACC.tape);
    if (S.battery)   m.push(ACC.battery);
    return m;
  }
  function finishName() { return S.wallFinish.charAt(0).toUpperCase() + S.wallFinish.slice(1); }
  /* 1.7.0 - THE ORDER LINE, per the live Paid -> Cindy parser (Zap 280313383 / 333962849 v39, read from its own run
     data on 24 Sep 2026; work/b8/trace/ZAP-TRACE-2026-09-24.md). Each key is one the parser reads; the column it fills
     is noted. The order service's catalogue module builds the same object server-side and the cart adds THAT copy. */
  function properties() {
    var p = {};
    /* D - the parser takes 'Neon Colour' (or the variant title after "/", which a made-to-order product has not got) */
    var colour = CFG.colourMode === 'selectable' ? S.colour
               : CFG.colourMode === 'fixed-single' ? (CFG.fixedColour || '')
               : (MFG.colours && MFG.colours.length ? MFG.colours.join(', ') : '');   /* 1.9.0: the production record; none -> not buyable */
    if (colour) p['Neon Colour'] = colour;
    p['Sign Size'] = lineSize();                                              /* 1.12.0: ONE size line, the customer's unit */
    p['Indoor or Outdoor'] = S.outdoor ? 'Outdoor' : 'Indoor';               /* H */
    p['Sign Shape'] = CFG.signShape || 'Cut To Shape';                       /* I */
    /* G - 1.9.0: Clear, or UV Print for printed / infilled artwork (tnf-cat-mfg-1-1-0.js) */
    p['Backboard Colour'] = CFG.backboardColour === 'UV Print' ? 'UV Print' : 'Clear';
    p['Power Adapter'] = plugProperty();                                     /* M -> AU / US / UK / EU */
    p['Additional Options'] = mountingList().join(', ');                     /* J and L (the parser scans this key) */
    /* K - a direct 'Wall Mounting Kit' key wins over the scan and is written verbatim unless it is a yes/no word,
       so the factory sees the finish: Silver / Black / Gold. No kit: no key, and the scan writes "No". */
    if (S.wallMount) p['Wall Mounting Kit'] = finishName();
    /* 1.12.0 - hidden (never shown at checkout or on the order status page; the parser's grouping ignores "_" keys):
       the factory's centimetre size (column F, verbatim - the Paid -> Cindy parser reads hidden keys too) and the
       packing plan (no sheet column reads it; the note under the size selector still tells the customer) */
    p._tnf_size_cm = factorySize();
    var pl = partsLine(); if (pl) p._tnf_supplied_in = pl.supplied;
    /* the cart's link back to this page */
    p._tnf_design = CFG.handle;
    p._tnf_cfg = cfgParam();
    return p;
  }
  function cfgParam() {
    var a = ['w=' + Math.round(toDisp(S.width_mm))];
    if (CFG.colourMode === 'selectable' && S.colour) a.push('colour=' + encodeURIComponent(S.colour));
    if (S.outdoor) a.push('use=outdoor');
    if (S.wallMount) a.push('wall=' + S.wallFinish);
    if (S.hanging) a.push('hang=1');
    if (S.tape) a.push('tape=1');
    if (!S.dimmer) a.push('dimmer=0');
    if (S.battery) a.push('battery=1');
    a.push('plug=' + encodeURIComponent(S.plug));                     /* 1.9.0: the plug selected is the plug ordered - always */
    return a.join('&');
  }

  /* ---- rendering -------------------------------------------------------- */
  function syncWidthUI() {
    if (!READY.size) { var dz = $('#tnf-cat-dims'); if (dz) dz.hidden = true; return; }
    var slider = $('#tnf-cat-w'), num = $('#tnf-cat-wnum');
    var lo = minW(), hi = maxW();
    slider.min = String(Math.round(toDisp(lo)));
    slider.max = String(Math.round(toDisp(hi)));
    slider.step = '1';
    slider.value = String(Math.round(toDisp(S.width_mm)));
    /* The number field gets the SAME limits as the slider, so the browser's
       own stepper, the mobile keypad's up/down and form validation all stop
       at the product's minimum rather than only the JS clamp catching it. */
    num.min = slider.min; num.max = slider.max; num.step = '1';
    if (document.activeElement !== num) num.value = String(Math.round(toDisp(S.width_mm)));
    $('#tnf-cat-wunit').textContent = unit();
    $('#tnf-cat-wmin').textContent = Math.round(toDisp(lo)) + ' ' + unit();
    $('#tnf-cat-wmax').textContent = Math.round(toDisp(hi)) + ' ' + unit();
    $('#tnf-cat-wdec').disabled = S.width_mm <= lo + 1e-6;
    $('#tnf-cat-winc').disabled = S.width_mm >= hi - 1e-6;
    $('#tnf-cat-hout').textContent = (S.market === 'US'
      ? (Math.round(toDisp(height_mm()) * 2) / 2) : Math.round(toDisp(height_mm()))) + ' ' + unit();
    var d = $('#tnf-cat-dims');
    if (d) {
      d.querySelector('b').textContent = dimsLabel();
      var alt = d.querySelector('.tnf-cat-alt');
      alt.textContent = altLabel(); alt.hidden = !altLabel();
    }
    syncParts();
  }

  /* EVERY width change goes through here: slider drag, slider keyboard, the
     minus and plus buttons, a committed typed value, and a width restored
     from the URL. Snapping happens INSIDE the clamp, never after it, so a
     snap can never carry a value back under the minimum. */
  function setWidth(mm, fromUser) {
    var lo = minW(), hi = maxW();
    mm = Math.min(hi, Math.max(lo, snap(Math.min(hi, Math.max(lo, mm)))));
    /* S.width_mm is now an exact multiple of the market step and every
       consumer (price, preview, factory record) reads it, so they cannot
       diverge. No further rounding: see MANUFACTURING PRECISION above. */
    S.width_mm = mm;
    if (fromUser) S.widthTouched = true;
    syncWidthUI(); refresh();
  }

  /* Last line of defence before anything leaves the browser. Nothing is
     quoted, added to a cart or sent to the service unless the width is at or
     above this product's own minimum. The server must repeat this check
     against the product's metafields - a minimum supplied by the browser is
     never to be trusted. */
  function widthIsPermitted() {
    return sizeOk() &&
           S.width_mm >= minW() - 1e-6 && S.width_mm <= maxW() + 1e-6;
  }

  function renderColours() {
    var wrap = $('#tnf-cat-colours');
    if (!wrap) return;                      /* fixed-single / fixed-design: no selector rendered */
    wrap.innerHTML = '';
    COLOURS.forEach(function (c) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'tnf-colour';
      b.setAttribute('data-colour', c.name);
      b.setAttribute('aria-pressed', c.name === S.colour ? 'true' : 'false');
      b.innerHTML = '<span class="tnf-colour-lit" style="color:' + c.hex + ';background:' + c.hex + '"></span>' +
                    '<span class="tnf-colour-name"></span>';
      b.querySelector('.tnf-colour-name').textContent = c.name;
      b.addEventListener('click', function () { selectColour(c.name); });
      wrap.appendChild(b);
    });
  }
  /* one path for every way a colour is chosen - its swatch or its photo's thumbnail */
  function selectColour(name) {
    if (!COLOURS.some(function (c) { return c.name === name; })) return;
    S.colour = name;
    $$('#tnf-cat-colours .tnf-colour').forEach(function (o) { o.setAttribute('aria-pressed', String(o.getAttribute('data-colour') === name)); });
    showColourMedia(name);
    syncQuoteLink();
    refresh();
  }
  /* the colour whose own photo a thumbnail shows (the current colour wins when two colours share a photo) */
  function colourForMedia(id) {
    var map = CFG.colourMedia || {}, hit = null;
    Object.keys(map).forEach(function (name) { if (map[name] && String(map[name].id) === String(id)) { if (!hit || name === S.colour) hit = name; } });
    return hit;
  }
  function bindThumbs() {
    $$('.tnf-cat-thumb').forEach(function (t) {
      if (t.__tnfBound) return; t.__tnfBound = true;
      t.addEventListener('click', function () {
        var name = CFG.colourMode === 'selectable' ? colourForMedia(t.dataset.mediaId) : null;
        if (name) { selectColour(name); return; }                      /* 1.3.1: also while the price is to be confirmed */
        setHero(t.dataset.full, t.dataset.mediaId, null);
      });
    });
  }
  function bindPlug() {
    var plugSel = $('#tnf-cat-plug'); if (!plugSel || plugSel.__tnfBound) { syncPlug(); return; }
    plugSel.__tnfBound = true;
    syncPlug();
    plugSel.addEventListener('change', function () { if (PLUGS.indexOf(this.value) >= 0) { S.plug = this.value; S.plugChosen = true; } syncPlug(); refresh(); });   /* 1.3.1: the pending summary lists the adapter too */
  }

  /* 1.3.2: amounts read the way the card badge writes them - thousands separated, cents only when there are any
     (A$4,477 / US$1,320 / A$473.60) - so the page and its card show the same figure the same way. Display only:
     the order properties carry no price, and the quote keeps its numbers. */
  function amtText(n) {
    if (typeof n === 'string') return n;
    var v = Math.round(Number(n) * 100) / 100; if (!isFinite(v)) return String(n);
    var s = v.toFixed(2).replace(/\.00$/, ''), parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }
  function money(n) { return cur() + amtText(n); }

  /* ---- colour -> the product's own image of that colour --------------------
     CFG.colourMedia maps each offered colour to the variant image the product
     itself carries for it (mapped in Liquid from the variants, never from the
     gallery order). The latest selection always wins: every load carries a
     sequence number and an older image that finishes later is discarded. A
     colour with no image of its own leaves the picture unchanged and says so. */
  var mediaSeq = 0;
  /* 1.2.0: the photo, its thumbnail highlight and the crop window change TOGETHER, and only for the
     newest selection: a request that is overtaken is dropped when it lands (the sequence check), so a
     slow earlier colour can never replace a later one. The crop is computed from the incoming photo's
     own size and sign position before it is shown, so the new colour appears already framed. */
  function markThumb(mediaId) {
    var strip = $('.tnf-cat-thumbs'), on = null;
    $$('.tnf-cat-thumb').forEach(function (t) { var s = !!mediaId && t.dataset.mediaId === String(mediaId); t.setAttribute('aria-selected', String(s)); if (s) on = t; });
    if (strip && on && strip.scrollWidth > strip.clientWidth + 2) {
      var l = on.offsetLeft - strip.offsetLeft, left = Math.max(0, l - (strip.clientWidth - on.offsetWidth) / 2);
      if (on.offsetLeft < strip.scrollLeft || on.offsetLeft + on.offsetWidth > strip.scrollLeft + strip.clientWidth) {
        try { strip.scrollTo({ left: left, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); } catch (e) { strip.scrollLeft = left; }
      }
    }
  }
  function setHero(src, mediaId, alt) {
    var hero = $('#tnf-cat-hero'); if (!hero) return;
    var seq = ++mediaSeq, pre = new Image();
    pre.onload = function () {
      if (seq !== mediaSeq) return;                 /* superseded by a newer selection */
      hero.setAttribute('data-media-id', mediaId || '');
      CROP.frameFor(mediaId, pre.naturalWidth, pre.naturalHeight);   /* frame the incoming photo with its own size ... */
      CROP.mediaChanged();                                            /* ... before it is shown */
      hero.src = src; if (alt) hero.alt = alt;
      hero.removeAttribute('data-media-error');
      markThumb(mediaId);
    };
    pre.onerror = function () { if (seq === mediaSeq) hero.setAttribute('data-media-error', src); };
    pre.src = src;
  }
  function showColourMedia(name) {
    var note = $('#tnf-cat-colournote');
    var m = (CFG.colourMedia || {})[name];
    /* EVERY selection supersedes any image still loading - including a colour with no image of its own,
       otherwise the previous colour's picture could arrive after this selection and be shown as this colour */
    ++mediaSeq;
    if (m && m.src) { setHero(m.src, m.id, m.alt); if (note && !note.hidden) { note.hidden = true; note.textContent = ''; CROP.chipsChanged(); } return; }
    /* no image of this colour on the product: never tint the photograph, never show another colour as if it were this one */
    if (note) { note.hidden = false; note.textContent = 'Photo shows the sign as photographed - yours is made in ' + name + '.'; CROP.chipsChanged(); }
  }

  /* ---- promotion display (1.1.2, prepared for a FUTURE automatic discount) ----
     tnf-promo-1-0-0.js owns the promotion definition (window.TNF_PROMO, connection
     pending) and the preview-only fixture. This hook only DISPLAYS what that
     definition says for this product: the genuine quote is the regular price,
     the promotion is applied to the sign (accessories excluded when the
     definition says so), and the charge itself is untouched - Shopify's
     automatic discount prices the cart and checkout. Nothing applies when no
     promotion is in force, and every sale mark is removed again. */
  var ACCESSORY_KEYS = { wall_mounting_kit: 1, hanging_kit: 1, tape_3m: 1, battery_pack: 1 };
  var PROMO = (function () {
    function ctx() {
      var el = document.createElement('div');
      el.setAttribute('data-tnf-handle', CFG.handle || ''); el.setAttribute('data-tnf-tags', (CFG.tags || []).join(','));
      el.setAttribute('data-tnf-collections', (CFG.collections || []).join(',')); el.setAttribute('data-tnf-accessory', 'false');
      return el;
    }
    function calc(q) {
      if (!q || !q.ok) return null;
      /* 27 Sep 2026: the pricing engine now applies the sale itself, so when a
         quote already carries one the only job left here is to SHOW it. The
         reduction is never recomputed from q.payable, because q.payable is the
         reduced price - discounting it again is exactly how one sale becomes
         two. q.regularPayable is the engine's own undiscounted figure, so the
         struck price, the price paid and the saving all come from the same
         calculation the server will charge. */
      if (q.promotion && q.regularPayable != null && q.regularPayable > q.payable) {
        return { id: q.promotion.id, title: q.promotion.title,
                 regular: q.regularPayable, payable: q.payable,
                 saved: Math.round((q.regularPayable - q.payable) * 100) / 100,
                 label: 'Save ' + q.promotion.percent + '%',
                 percent: q.promotion.percent, accessories: accessoryTotal(q),
                 fixture: false, fromEngine: true };
      }
      var api = window.TNF_PROMO_API; if (!api) return null;
      var p = api.promotion(); if (!p || !api.eligible(p, ctx())) return null;
      var acc = 0;
      if (p.exclude && p.exclude.accessories) acc = accessoryTotal(q);
      var base = q.payable - acc; var sale = api.discounted(p, base); if (sale == null) return null;
      var payable = Math.round((sale + acc) * 100) / 100;
      return { id: p.id, title: p.title, regular: q.payable, payable: payable, saved: Math.round((q.payable - payable) * 100) / 100, label: p.kind === 'percentage' ? 'Save ' + (Math.round(Number(p.value) * 10) / 10) + '%' : 'Save ' + money(Math.round((q.payable - payable) * 100) / 100), percent: p.kind === 'percentage' ? (Math.round(Number(p.value) * 10) / 10) : null, accessories: acc, fixture: !!p.fixture };
    }
    /* the accessories the sale never touches, at this quantity */
    function accessoryTotal(q) {
      var acc = 0;
      ((q && q.addOns && q.addOns.items) || []).forEach(function (a) {
        if (ACCESSORY_KEYS[a.key]) acc += (Number(a.amount) || 0) * Math.max(1, S.qty || 1);
      });
      return Math.round(acc * 100) / 100;
    }
    /* ---- the picture's price chip -----------------------------------------
       It carries the SAME three-line sale badge the custom creator uses: the
       regular price struck through, the price being charged under it, and a
       compact offer label. The creator's chip is written into its own markup;
       this one is assembled here, so a catalogue product needs no template
       change and assets/tnf-promo-1-2-0.css styles both from one rule set -
       one badge design in two places, not two that drift apart. The label says
       "25% OFF SIGN" when the total carries accessories the sale does not
       touch, exactly as the creator's does. */
    function chipNow(chip) {
      var now = chip.querySelector('.tnf-pc-now');
      if (!now) {
        var cur = chip.querySelector('#tnf-cat-pc-cur'), amt = chip.querySelector('#tnf-cat-pc-amt');
        if (!cur || !amt) return null;
        now = document.createElement('span'); now.className = 'tnf-pc-now';
        cur.parentNode.insertBefore(now, cur);
        now.appendChild(cur); now.appendChild(amt);
      }
      return now;
    }
    function plainChip(chip) {
      chip.classList.remove('is-sale');
      var w = chip.querySelector('.tnf-pc-was'); if (w) w.parentNode.removeChild(w);
      var o = chip.querySelector('.tnf-pc-off'); if (o) o.parentNode.removeChild(o);
    }
    function saleChip(chip, d) {
      var amt = chip.querySelector('#tnf-cat-pc-amt');
      if (amt) amt.textContent = fmtN(d.payable);
      var now = chipNow(chip);
      chip.classList.add('is-promo');
      if (!now || d.percent == null) { plainChip(chip); return; }
      var was = chip.querySelector('.tnf-pc-was');
      if (!was) { was = document.createElement('s'); was.className = 'tnf-pc-was'; chip.insertBefore(was, now); }
      was.textContent = money(fmtN(d.regular));
      var off = chip.querySelector('.tnf-pc-off');
      if (!off) { off = document.createElement('span'); off.className = 'tnf-pc-off';
                  if (now.nextSibling) chip.insertBefore(off, now.nextSibling); else chip.appendChild(off); }
      off.textContent = d.percent + '% OFF' + (d.accessories > 0 ? ' SIGN' : '');
      chip.classList.add('is-sale');
    }
    function fmtN(n) { var s = (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, ''); var parts = s.split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); return parts.join('.'); }
    /* 1.2.0: what is in force right now, as a key - used to notice a promotion ending or starting while the
       page is open. decorate() only ever ADDS the sale marks on top of a freshly rendered regular state
       (refresh() renders the regular price everywhere first), so a change of key always goes through
       refresh(): main price, picture chip, sticky bar, summary and their accessible labels are rewritten
       from the quote and no struck price or saving can survive the promotion. */
    function key(q) { var d = calc(q); return d ? d.id + '|' + d.payable : ''; }
    function decorate(q) {
      var d = calc(q); S.promo = d; S.promoKey = d ? d.id + '|' + d.payable : '';
      document.documentElement.classList.toggle('tnf-cat-promo', !!d);
      var head = $('#tnf-cat-headprice'), chip = $('#tnf-cat-pricechip'), bar = $('#tnf-cat-sticky'), box = $('#tnf-cat-total');
      var old = $('#tnf-cat-promo-row'); if (old) old.parentNode.removeChild(old);
      if (!d) { if (chip) { chip.classList.remove('is-promo'); plainChip(chip); } return; }
      if (head && !head.hidden) head.querySelector('.tnf-cat-hp-amt').innerHTML = '<s class="tnf-cat-was">' + money(fmtN(d.regular)) + '</s> ' + money(fmtN(d.payable)) + ' <span class="tnf-cat-save">' + d.label + '</span>';
      if (chip) { saleChip(chip, d); chip.setAttribute('aria-label', 'Sale price ' + money(fmtN(d.payable)) + ', regular ' + money(fmtN(d.regular))); }
      if (bar) bar.querySelector('.tnf-cat-sb-price').firstChild.nodeValue = money(fmtN(d.payable));
      if (box) {
        var price = box.querySelector('.tnf-cat-price');
        if (price) price.innerHTML = '<s class="tnf-cat-was">' + money(fmtN(d.regular)) + '</s> <span class="tnf-cat-cur">' + curPre() + curSym() + '</span>' + fmtN(d.payable) + ' <span class="tnf-cat-save">' + d.label + '</span>';
        var row = document.createElement('div'); row.className = 'tnf-cat-promo-row'; row.id = 'tnf-cat-promo-row';
        row.textContent = (d.fixture ? '[Preview fixture - not a real promotion] ' : '') + d.title + ': ' + money(fmtN(d.saved)) + ' off, already included in this price.';
        box.appendChild(row);
      }
    }
    /* called by the promotion layer's change event, on load and on a slow safety timer */
    function recheck() { var q = window.__tnfCatLastQuote; if (!q) return; if (key(q) !== (S.promoKey || '')) refresh(); }
    return { decorate: decorate, calc: calc, recheck: recheck };
  })();

  function refresh() {
    var box = $('#tnf-cat-total'), btn = $('#tnf-cat-add');
    var q = quote();
    if (!q) { box.innerHTML = '<p class="tnf-cat-blocked">Pricing is still loading.</p>'; btn.disabled = true; publishPrice(null); return; }
    window.__tnfCatLastQuote = q;

    if (!q.ok) {
      var why = ({
        below_minimum_width: 'That is smaller than this design can be made.',
        above_product_maximum: 'That is larger than we currently make this design.',
        above_market_maximum: 'That is wider than we can build for this market.',
        battery_not_offered_colour_mode: 'The battery pack is not offered with a colour-changing controller. Untick it to order this sign on mains power.',
        outdoor_power_over_12m: 'This size outdoors needs the manufacturer to size the power supply, so we price it by hand.',
        /* 1.3.0: the design itself cannot be priced online yet - every option stays, nothing is estimated */
        uk_quote_required: 'Choose your size and options, then request a quote \u2013 we confirm your UK price and delivery time within one working day.',
        uk_quote_required_cost_unverified: 'Choose your size and options, then request a quote \u2013 we confirm your UK price and delivery time within one working day.',
        no_tube_length: 'Choose your size and options, then request a quote \u2013 we confirm the price and delivery time within one working day.',
        size_record: 'Choose your options and request a quote \u2013 we confirm the size, price and delivery time within one working day.'
      })[q.blocking[0]] || 'We price this configuration by hand.';
      /* 1.3.0: while the design itself is being priced the summary still summarises everything chosen -
         size, use, colour, backboard, extras, plug - with no amount anywhere */
      var conf = '';
      if (q.readiness) {
        var esc = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
        conf = '<div class="tnf-cat-sub" style="margin:0 0 8px">' + esc((READY.size && dimsLabel() ? dimsLabel() + ' \u00b7 ' : '') + (S.outdoor ? 'Outdoor' : 'Indoor') + (colourText() ? ' \u00b7 ' + colourText() : '')) + '</div>' +
          '<ul class="tnf-cat-rows tnf-cat-rows--conf"><li><span>Backboard \u00b7 ' + esc(boardText()) + '</span><span>Included</span></li>' +
          mountingList().map(function (t) { return '<li><span>' + esc(t) + '</span><span>' + (/^Free /.test(t) ? 'Included' : 'Quoted with the sign') + '</span></li>'; }).join('') +
          '<li><span>Power adapter \u00b7 ' + esc(S.plug) + '</span><span>Included</span></li>' + partsRow() + '</ul>';
      }
      box.innerHTML = '<div class="tnf-cat-blocked' + (q.readiness ? ' tnf-cat-blocked--pending' : '') + '"><strong>' + (q.readiness ? 'Price to be confirmed' : 'Ask us for a price') + '</strong>' + conf +
        (q.readiness ? '<p class="tnf-cat-pending-why">' + why + '</p>' : why) +
        ' <a class="tnf-btn ' + (q.readiness ? 'tnf-btn-primary tnf-cta' : 'tnf-btn-ghost') + '" style="margin-top:12px" data-tnf-quote href="' + quoteHref().replace(/"/g, '&quot;') + '">Request a quote</a>' +
        (q.readiness ? '<p class="tnf-cat-pending-note">Add to cart opens once this design is priced.</p>' : '') + '</div>';
      btn.disabled = true; syncSticky(q); syncHead(null); syncChip(null, why); syncBatteryNote(q); PROMO.decorate(null); CROP.chipsChanged(); publishPrice(q); return;
    }

    var rows = q.addOns.items.map(function (a) {
      return '<li><span></span><span>' + a.display + '</span></li>';
    });
    var html = '<div class="tnf-cat-price"><span class="tnf-cat-cur">' + curPre() + curSym() +
      '</span>' + amtText(q.payable) + '</div>' +
      '<div class="tnf-cat-sub" style="margin-top:8px">' + dimsLabel() + ' · ' +
      (S.outdoor ? 'Outdoor' : 'Indoor') + (colourText() ? ' · ' + colourText() : '') + '</div>';
    if (q.addOns.items.length) {
      html += '<ul class="tnf-cat-rows">' + q.addOns.items.map(function (a) {
        return '<li><span>' + a.label + '</span><span>' + a.display + '</span></li>';
      }).join('') + '</ul>';
    }
    html += '<ul class="tnf-cat-rows tnf-cat-rows--plug"><li><span>Backboard \u00b7 ' + boardText() + '</span><span>Included</span></li>' +
      '<li><span>Power adapter · ' + S.plug + '</span><span>Included</span></li>' + partsRow() + '</ul>';
    if (q.market === 'AU') html += '<div class="tnf-cat-tax">Includes GST of $' + q.tax.component.toFixed(2) + '</div>';
    if (q.market === 'UK' && q.tax && q.tax.component != null) html += '<div class="tnf-cat-tax">Includes VAT of \u00a3' + q.tax.component.toFixed(2) + '</div>';
    /* 1.6.0: no purchase path connected -> the price stands, Add to cart is disabled and says why, and the quote
       request carries this exact configuration and price */
    if (!CAN_BUY) html += '<div class="tnf-cat-nocart"><p class="tnf-cat-pending-note">Online checkout for this made-to-size sign isn\u2019t available yet. Request a quote and we\u2019ll confirm this price and the delivery time within one working day.</p>' +
      '<a class="tnf-btn tnf-btn-primary tnf-cta" style="margin-top:10px" data-tnf-quote href="' + quoteHref().replace(/"/g, '&quot;') + '">Request a quote</a></div>';
    box.innerHTML = html;
    if (!ADDING && btn.classList.contains('is-added')) setBusy(false);     /* 1.11.0: a new choice after "Added" */
    btn.disabled = !CAN_BUY || ADDING;
    btn.setAttribute('aria-disabled', String(!CAN_BUY || ADDING));
    syncSticky(q);
    syncHead(q);
    syncChip(q, null);
    syncBatteryNote(q);
    PROMO.decorate(q);
    CROP.chipsChanged();
    publishPrice(q);
    schedulePrefetch();                        /* 1.11.0: the service's quote for this configuration, in the background */
  }

  /* 1.7.1: the price the customer sees, for listeners that must show the same amount (the Afterpay message,
     assets/tnf-afterpay-1-0-0.js): the quote's payable after any promotion the page displays (S.promo is set
     by PROMO.decorate just before), or null while no price is shown. */
  function publishPrice(q) {
    var ok = !!(q && q.ok);
    var d = { source: 'catalogue', ok: ok, amount: ok ? (S.promo ? S.promo.payable : q.payable) : null,
              regular: ok ? q.payable : null, currency: q ? q.currency : null, market: q ? q.market : null };
    window.__tnfCatPrice = d;
    try { document.dispatchEvent(new CustomEvent('tnf:price', { detail: d })); } catch (e) {}
  }

  /* 1.9.0: the packing plan in the summary - only when the sign is made in more than one piece */
  function partsRow() {
    var pl = READY.size ? partsLine() : null;
    return pl ? '<li class="tnf-cat-partsrow"><span>Supplied in</span><span>' + pl.supplied + '</span></li>' : '';
  }

  /* Price chip in the picture's top-left corner: the same quote as the summary,
     never a second calculation. Blocked: the amount gives way to a short note. */
  function syncChip(q, why) {
    var chip = $('#tnf-cat-pricechip'); if (!chip) return;
    var curEl = $('#tnf-cat-pc-cur'), amt = $('#tnf-cat-pc-amt'), note = $('#tnf-cat-pc-note');
    chip.classList.toggle('is-blocked', !q);
    /* refresh() renders the regular state first and decorate() adds the sale on
       top, so the struck price and the offer label are cleared here or a stale
       pair could outlive a promotion that has just ended. */
    chip.classList.remove('is-sale');
    var wasEl = chip.querySelector('.tnf-pc-was'); if (wasEl) wasEl.parentNode.removeChild(wasEl);
    var offEl = chip.querySelector('.tnf-pc-off'); if (offEl) offEl.parentNode.removeChild(offEl);
    if (q) { curEl.textContent = curPre() + curSym(); amt.textContent = amtText(q.payable); note.hidden = true; note.textContent = ''; chip.setAttribute('aria-label', 'Current price ' + money(q.payable)); }
    else   { var t = READY.price ? 'Ask us for a price' : 'Price to be confirmed'; curEl.textContent = ''; amt.textContent = ''; note.hidden = false; note.textContent = t; chip.setAttribute('aria-label', t); }
  }
  /* The creator's battery note, word for word (tnf-creator 2.5.10 renderNotices). */
  function syncBatteryNote(q) {
    var bn = $('#tnf-cat-batterynote'); if (!bn) return;
    var bblock = (q && q.blocking) || [];
    if (!S.battery) { bn.hidden = true; return; }
    bn.hidden = false;
    bn.textContent = bblock.indexOf('battery_not_offered_colour_mode') >= 0
      ? 'The battery pack is not offered with Premium RGB or RGBW - the colour controller draws more power than we can promise the pack will supply. Choose a single colour to use it, or untick it to order this sign on mains power.'
      : 'Runtime is an estimate: battery life varies with sign size, brightness and the batteries you use, and a bigger or brighter sign runs the pack down faster. Your sign also comes with its mains adapter.';
  }

  /* Price and dimensions at the TOP of the panel too, so they are prominent
     before the customer scrolls through the options. Same quote object, same
     numbers - never a second calculation. */
  function syncHead(q) {
    var el = $('#tnf-cat-headprice'); if (!el) return;
    if (!q) { el.hidden = true; return; }
    el.hidden = false;
    el.querySelector('.tnf-cat-hp-amt').textContent = money(q.payable);
    el.querySelector('.tnf-cat-hp-dims').textContent = dimsLabel() + ' · ' + (S.outdoor ? 'Outdoor' : 'Indoor');
  }

  function syncSticky(q) {
    var bar = $('#tnf-cat-sticky'); if (!bar) return;
    var priced = !!(q && q.ok !== false);
    bar.querySelector('.tnf-cat-sb-price').firstChild.nodeValue = priced ? money(q.payable) : (q && q.readiness ? 'Price to be confirmed' : '\u2014');
    bar.querySelector('.tnf-cat-sb-size').textContent = (READY.size && dimsLabel() ? dimsLabel() + ' \u00b7 ' : '') + (S.outdoor ? 'Outdoor' : 'Indoor');
    var btn = bar.querySelector('button'); btn.disabled = !priced || !CAN_BUY || ADDING;
    /* 1.3.0: while a design or configuration is quoted by hand, the bar carries the quote request (the page's
       main action) instead of a disabled Add to cart */
    var ql = bar.querySelector('a[data-tnf-quote]');
    if ((q && q.ok === false) || (priced && !CAN_BUY)) {
      if (!ql) { ql = document.createElement('a'); ql.className = 'tnf-btn tnf-btn-primary tnf-cat-sb-quote'; ql.setAttribute('data-tnf-quote', ''); ql.textContent = 'Request a quote'; btn.parentNode.insertBefore(ql, btn); }
      ql.setAttribute('href', quoteHref()); ql.hidden = false; btn.hidden = true;
    } else { if (ql) ql.hidden = true; btn.hidden = false; }
  }

  /* ---- authoritative charge -------------------------------------------- */
  function resolveVariant(q) {
    if (ORDER.source === 'variants') {
      var key = Math.round(q.geometry.board.w_mm) + '|' + (S.outdoor ? 'outdoor' : 'indoor') + '|' + S.colour;
      var v = (ORDER.variants || {})[key];
      if (!v) return Promise.reject(new Error('no_variant'));
      /* the variant's OWN price is the charge - verify it matches the quote */
      if (Math.round(Number(v.price)) !== Math.round(q.payable))
        return Promise.reject(new Error('price_mismatch'));
      return Promise.resolve({ variantId: v.id, quantity: S.qty, properties: properties() });
    }
    if (ORDER.source === 'service' && ORDER.service) {
      var attempt = function (fresh) {
        var sqUsed = null;
        return serverQuote(fresh).then(function (sq) {
          sqUsed = sq;
          if (!sq || !sq.ok) throw new Error('quote_failed');
          if (sq.version) RENEW_OK = newerThan150(sq.version);     /* order module 1.5.0+ can replace a refused product */
          /* 1.8.0: a service in test (dry-run) mode is never a purchase path - stop before asking it for a line */
          if (sq.dryRun || sq.mode === 'dry-run') throw new Error('dry_run');
          if (Number(sq.payable) !== Number(q.payable)) { S.serverPrice = sq.payable; PREQ = null; throw new Error('requote'); }
          mark('orderStart');
          return svcPost('/order', Object.assign({}, quoteCfg(), { token: sq.token, properties: properties() }), SVC_TIMEOUT.order);
        }).then(function (o) {
          mark('orderEnd'); if (T_ADD) T_ADD.orderEndAbs = performance.now();
          /* the service was started with its dry-run switch: whatever it says, nothing is bought (1.8.0: also a result
             that calls itself not actionable or test, and one that found an existing product while testing) */
          if (o && (o.dryRun || o.actionable === false || o.mode === 'dry-run')) throw new Error('dry_run');
          /* 1.11.0: a background quote the server no longer accepts is asked for again, once */
          if (o && !fresh && (o.error === 'quote_expired_or_invalid' || o.error === 'configuration_changed_since_quote')) { PREQ = null; return attempt(true); }
          if (!o || !o.ok || !o.variantId) throw new Error(o && o.error || 'order_failed');
          if (T_ADD) { T_ADD.server = o.timing || null; T_ADD.reused = o.reused ? (o.reusedFrom || true) : false; T_ADD.photoPath = o.photoPath || null; }
          return { variantId: String(o.variantId).split('/').pop(), quantity: S.qty, properties: o.properties || properties(), token: sqUsed && sqUsed.token };
        });
      };
      return attempt(false);
    }
    return Promise.reject(new Error('no_price_source'));
  }

  /* SERVER-SIDE ENFORCEMENT - PENDING, NOT TESTED.
     The service must re-derive this product's minimum from its own Shopify
     metafields and reject anything below it, exactly as it must re-derive the
     price. The width below travels with the request so the rejection can name
     the offending value, but the service must NEVER take min_width_cm from
     the browser as the limit - it is diagnostic only. Marked pending until it
     has genuinely been tested end to end against a live service. */
  function serverSizeGuardPayload() {
    return { handle: CFG.handle, market: S.market,
             width_mm: S.width_mm, height_mm: height_mm(), mfg_grid_mm: MFG_MM,
             factory_size_cm: factorySize(), height_precision_mm: MFG_MM,
             client_min_cm: CFG.minWidth_cm, client_min_source: CFG.minSource };
  }

  /* ---- 1.11.0: a fast, confirmed Add to cart ---------------------------------------------------------------- */
  function mark(k) { if (T_ADD && T_ADD[k] === undefined) T_ADD[k] = Math.round(performance.now() - T_ADD.t0); }
  /* a service call: text/plain (a CORS "simple" request - no preflight round trip; the service reads the JSON body
     whatever its type), a time limit, and errors a customer can act on */
  function svcPost(path, body, ms) {
    var ctl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, ms) : null;
    var stop = function () { if (timer) clearTimeout(timer); };
    return fetch(ORDER.service + path, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(body), signal: ctl ? ctl.signal : undefined })
      .then(function (r) {
        if (r.status === 429) throw new Error('busy');
        if (r.status >= 500 && r.status !== 503) throw new Error('service_down');
        if (r.status === 503) throw new Error('busy');
        return r.json();
      }, function (e) { throw new Error(e && e.name === 'AbortError' ? 'timeout' : 'network'); })
      .then(function (j) { stop(); return j; }, function (e) { stop(); throw e; });
  }
  function cfgKey() { return JSON.stringify(quoteCfg()); }
  /* the service's quote for the configuration on screen, asked for once it has settled; the service starts its reuse
     lookup at the same time. Only ever used for exactly this configuration (the key is the whole request) */
  /* a service whose order module is older than 1.5.0 reads the product from Shopify on every quote (no cache): then
     only the first background quote of the page is asked for, and the rest at the press, as before */
  var PREFETCH_OK = true;
  function newerThan150(v) { var a = String(v || '0').split('.').map(Number); return a[0] > 1 || (a[0] === 1 && (a[1] || 0) >= 5); }
  function prefetchQuote() {
    if (!CAN_BUY || ADDING || !PREFETCH_OK || document.hidden) return;
    var q = window.__tnfCatLastQuote; if (!q || !q.ok) return;
    var key = cfgKey();
    if (PREQ && PREQ.key === key && Date.now() - PREQ.at < 15 * 60 * 1000) return;
    if (PREQ_PENDING && PREQ_PENDING.key === key) return;
    var p = svcPost('/quote', quoteCfg(), SVC_TIMEOUT.quote).then(function (sq) {
      if (sq && sq.ok) PREQ = { key: key, at: Date.now(), sq: sq };
      if (sq && sq.version && !newerThan150(sq.version)) PREFETCH_OK = false;
      return sq;
    });
    var mine = { key: key, p: p };
    PREQ_PENDING = mine;
    var done = function () { if (PREQ_PENDING === mine) PREQ_PENDING = null; };
    p.then(done, done);
  }
  function schedulePrefetch() { clearTimeout(PREQ_TIMER); if (CAN_BUY) PREQ_TIMER = setTimeout(prefetchQuote, 700); }
  function serverQuote(fresh) {
    var key = cfgKey();
    if (!fresh && PREQ && PREQ.key === key && Date.now() - PREQ.at < 20 * 60 * 1000) { mark('quoteReady'); return Promise.resolve(PREQ.sq); }
    if (!fresh && PREQ_PENDING && PREQ_PENDING.key === key) { mark('quoteAwaited'); return PREQ_PENDING.p.then(function (sq) { mark('quoteReady'); return sq; }); }
    mark('quoteStart');
    return svcPost('/quote', quoteCfg(), SVC_TIMEOUT.quote).then(function (sq) {
      mark('quoteReady');
      if (sq && sq.ok) PREQ = { key: key, at: Date.now(), sq: sq };
      return sq;
    });
  }

  /* 1.7.0: the add-attempt note (tnf-creator 2.5.7 pattern): sessionStorage survives a reload mid-add; an in-memory copy
     covers private windows; unreadable -> the old behaviour, never a failure */
  var ADD_NOTE = 'tnf-cat-add-attempt', addNoteMem = null;
  function readAddNote() { try { var v = sessionStorage.getItem(ADD_NOTE); if (v) return JSON.parse(v); } catch (e) {} return addNoteMem; }
  function writeAddNote(v) { addNoteMem = v; try { if (v) sessionStorage.setItem(ADD_NOTE, JSON.stringify(v)); else sessionStorage.removeItem(ADD_NOTE); } catch (e) {} }
  function cartJSON() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function qtyOf(cart, vid) { if (!cart || !cart.items) return null; var n = 0; cart.items.forEach(function (it) { if (String(it.variant_id) === vid) n += it.quantity; }); return n; }
  function cartAdd(line) {
    var ctl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, SVC_TIMEOUT.cart) : null;
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin',
      body: JSON.stringify({ id: line.variantId, quantity: line.quantity, properties: line.properties, sections: drawerWanted() ? DRAWER_SECTION : undefined }), signal: ctl ? ctl.signal : undefined
    }).then(function (r) {
      if (timer) clearTimeout(timer);
      return r.json().catch(function () { return null; }).then(function (j) {
        if (!r.ok) { var e = new Error('cart_rejected'); e.status = r.status; e.detail = j && (j.description || j.message) || null; throw e; }
        return j;
      });
    }, function (e) { if (timer) clearTimeout(timer); throw new Error(e && e.name === 'AbortError' ? 'cart_unknown' : 'cart_unknown'); });
  }
  /* A brand-new product (made by this press) is added only once it has existed for a moment. Measured 26 Sep on the
     preview: a cart add that reaches Shopify before its storefront knows a new variant is refused ("Cannot find
     variant") - and Shopify's cart then keeps refusing that variant for several minutes (6-15 min observed). Adds made
     0.3-1.2 s after the order answered went through (the 1.10.0 flow read the cart first, which took ~0.3 s); adds
     made at once mostly didn't, and one at +2.4 s didn't either. So a new product waits until 1 s after the order
     answered; a refusal of a new variant is reported as variant_not_ready (addToCart then has the service replace the
     product - renew, service 1.3.0 - rather than asking again for a variant Shopify now refuses); a 429 (the storefront
     asking to slow down: nothing was added) is asked again after a pause, twice at most. */
  function cartAddNew(line, isNew, notBefore) {
    var tries429 = 0;
    function go() {
      return cartAdd(line).catch(function (e) {
        if (T_ADD && e.status) T_ADD.addErrors = (T_ADD.addErrors || []).concat([{ status: e.status, detail: e.detail, at: Math.round(performance.now() - T_ADD.t0) }]);
        if (e.message === 'cart_rejected' && e.status === 429 && tries429 < 2) { tries429++; mark('add429'); return new Promise(function (r) { setTimeout(r, 1200 * tries429); }).then(go); }
        if (e.message === 'cart_rejected' && isNew && (e.status === 422 || e.status === 404) && /find variant|not found|unavailable/i.test(String(e.detail || ''))) { var x = new Error('variant_not_ready'); x.status = e.status; throw x; }
        throw e;
      });
    }
    var wait = isNew ? Math.max(0, notBefore - performance.now()) : 0;
    if (wait > 0) { mark('addWait'); return new Promise(function (r) { setTimeout(r, wait); }).then(go); }
    return go();
  }
  /* the store's own side cart (the theme's quick cart: /cart?view=ajax_side_cart into #halo-cart-sidebar, as its own
     add-to-cart does, then the cart counts, the free-shipping message and the cart-update event); false = no drawer */
  function drawerWanted() {
    var a = window.after_add_to_cart, qc = window.quick_cart;
    return !!(document.getElementById('halo-cart-sidebar') && document.querySelector('#halo-cart-sidebar .previewCart-wrapper') &&
              a && a.type === 'quick_cart' && qc && qc.show && qc.type !== 'popup' && !document.body.classList.contains('template-cart'));
  }
  /* sections/tnf-side-cart.liquid renders the same side cart as the theme's /cart?view=ajax_side_cart; asked for with
     the add (Shopify's Section Rendering API), Shopify's answer to the add carries the refreshed drawer - no second
     request. Without it (an older theme), the drawer is fetched as the theme does. */
  var DRAWER_SECTION = 'tnf-side-cart';
  function sectionHTML(added) {
    var h = added && added.sections && added.sections[DRAWER_SECTION];
    if (!h || typeof h !== 'string') return null;
    return h.replace(/^\s*<div id="shopify-section-[^"]*"[^>]*>/, '').replace(/<\/div>\s*$/, '');
  }
  function drawerHTML() {
    if (!drawerWanted()) return Promise.resolve(null);
    return fetch('/cart?view=ajax_side_cart', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.text() : null; }).catch(function () { return null; });
  }
  function openDrawer(html, cart, count) {
    if (!html || !drawerWanted()) return false;
    var wrap = document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
    if (window.jQuery) window.jQuery(wrap).removeClass('is-loading').html(html); else wrap.innerHTML = html;   /* jQuery runs the drawer's own inline script, as the theme does */
    var n = cart ? cart.item_count : count;
    if (typeof n === 'number') $$('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    $$('[data-free-shipping-wrapper]').forEach(function (el) { el.dispatchEvent(new Event('change', { bubbles: true })); });
    document.body.classList.add('cart-sidebar-show');
    if (cart) { try { document.dispatchEvent(new CustomEvent('cart-update', { detail: cart })); } catch (e) {} }
    return true;
  }

  var ADD_LABEL = 'Add to cart';
  function setBusy(on, label, cls) {
    $$('#tnf-cat-add, #tnf-cat-add-sticky').forEach(function (b) {
      if (!b) return;
      b.classList.remove('is-adding', 'is-added');
      if (on) { b.setAttribute('aria-busy', 'true'); b.disabled = true; b.classList.add(cls || 'is-adding'); b.textContent = label || ADD_LABEL; }
      else    { b.removeAttribute('aria-busy'); b.textContent = ADD_LABEL; }
    });
  }
  function say(t) { var r = $('#tnf-cat-live'); if (r) { r.textContent = ''; setTimeout(function () { r.textContent = t; }, 30); } }
  function addToCartSetup() {
    if (CAN_BUY) {
      try { var l = document.createElement('link'); l.rel = 'preconnect'; l.href = new URL(ORDER.service, location.href).origin; l.crossOrigin = 'anonymous'; document.head.appendChild(l); } catch (e) {}
    }
    if (!document.getElementById('tnf-cat-add-style')) {
      var st = document.createElement('style'); st.id = 'tnf-cat-add-style';
      st.textContent = '.tnf-btn.is-adding,.tnf-btn.is-added{opacity:1!important;filter:none!important;cursor:progress}' +
        '.tnf-btn.is-added{cursor:default}' +
        '.tnf-btn.is-adding::before{content:"";display:inline-block;width:1em;height:1em;margin-right:.55em;vertical-align:-.16em;box-sizing:border-box;' +
        'border:2px solid currentColor;border-right-color:transparent;border-radius:50%;animation:tnf-cat-spin .7s linear infinite}' +
        '@keyframes tnf-cat-spin{to{transform:rotate(360deg)}}@media (prefers-reduced-motion:reduce){.tnf-btn.is-adding::before{animation-duration:2.4s}}' +
        '#tnf-cat-live{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}';
      document.head.appendChild(st);
    }
    if (!document.getElementById('tnf-cat-live')) { var lr = document.createElement('span'); lr.id = 'tnf-cat-live'; lr.setAttribute('aria-live', 'polite'); document.body.appendChild(lr); }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) schedulePrefetch(); });
  }

  /* the add for this press: a new product waits its moment (cartAddNew); if Shopify's cart refuses the new variant,
     a service that can (order module 1.5.0+) replaces the product - renew - and the replacement is added after a
     longer pause (2.5 s, then 4 s); at most twice. line.token is the signed quote the order was made with. */
  var RENEW_OK = false;
  function addWithRenew(line, n) {
    var isNew = !!(T_ADD && T_ADD.reused === false);
    var notBefore = (T_ADD && T_ADD.orderEndAbs ? T_ADD.orderEndAbs : performance.now()) + (n === 0 ? 1000 : (n === 1 ? 2500 : 4000));
    return cartAddNew(line, isNew, notBefore).then(function (added) {
      if (!added || String(added.variant_id) !== String(line.variantId)) throw new Error('cart_unknown');
      return added;
    }, function (e) {
      if (e.message !== 'variant_not_ready') throw e;
      if (!RENEW_OK || n >= 2 || !line.token) throw new Error('not_ready_yet');
      mark('renew' + (n + 1));
      return svcPost('/order', Object.assign({}, quoteCfg(), { token: line.token, properties: line.properties, renew: String(line.variantId) }), SVC_TIMEOUT.order).then(function (o) {
        if (!o || !o.ok || !o.variantId) throw new Error(o && o.error === 'renew_not_current' ? 'not_ready_yet' : (o && o.error || 'order_failed'));
        mark('renewed' + (n + 1));
        if (T_ADD) { T_ADD.reused = false; T_ADD.orderEndAbs = performance.now(); T_ADD.renewed = (T_ADD.renewed || 0) + 1; }
        var line2 = { variantId: String(o.variantId).split('/').pop(), quantity: line.quantity, properties: o.properties || line.properties, token: line.token };
        line.variantId = line2.variantId; line.properties = line2.properties;
        return addWithRenew(line, n + 1);
      });
    });
  }

  function addToCart() {
    var btn = $('#tnf-cat-add');
    var q = window.__tnfCatLastQuote;
    if (!q || !q.ok) return;
    /* Re-checked at the moment of the click, not only when the width changed,
       so a value forced in by devtools, an extension or a replayed event
       still cannot reach the cart. */
    if (!widthIsPermitted()) {
      var mm0 = $('#tnf-cat-msg');
      mm0.textContent = 'That size is outside the range this sign is made in (' +
        Math.round(toDisp(minW())) + '-' + Math.round(toDisp(maxW())) + ' ' + unit() +
        '). Nothing was added to your cart.';
      mm0.hidden = false;
      setWidth(S.width_mm, false);
      return;
    }
    if (ADDING || btn.getAttribute('aria-busy') === 'true') return;          /* already in flight: a second press does nothing */
    ADDING = true;
    T_ADD = { t0: performance.now(), at: new Date().toISOString() };
    setBusy(true, 'Adding…'); mark('ack');                            /* acknowledged in the same frame as the press */
    var msg = $('#tnf-cat-msg'); msg.hidden = true; msg.textContent = '';
    say('Adding your sign to the cart');
    clearTimeout(PREQ_TIMER);
    /* the cart as it was, read while the order is being made (the no-double-add rule needs it) */
    var before = cartJSON().then(function (c) { mark('cartRead'); return c; });
    var vid = null, line = null;
    resolveVariant(q).then(function (ln) {
      line = ln; vid = String(ln.variantId);
      /* 1.7.0 - the creator's rule (tnf-creator 2.5.7): retrying the service is safe (it reuses the product it made),
         retrying /cart/add.js is not - if an earlier add reached Shopify and only its answer was lost, the sign is
         already in the cart. A retry that finds MORE of this sign than the attempt started with doesn't add again. */
      return before.then(function (c0) {
        var n0 = qtyOf(c0, vid);
        var note = readAddNote();
        if (note && note.vid === vid && note.before >= 0 && n0 !== null && n0 > note.before) { writeAddNote(null); mark('alreadyInCart'); return { n0: note.before, already: true }; }
        writeAddNote({ vid: vid, before: n0 === null ? -1 : n0, at: Date.now() });
        mark('addStart');
        return addWithRenew(line, 0).then(function (added) {
          mark('addEnd'); writeAddNote(null);
          vid = String(line.variantId);                      /* a renewed product has a new variant */
          /* Shopify's own answer: the line it added (and the side cart rendered from the cart after the add) */
          if (!added || String(added.variant_id) !== vid) throw new Error('cart_unknown');
          return { n0: n0, already: false, html: sectionHTML(added), count0: c0 && c0.item_count };
        }, function (e) {
          mark('addEnd');
          if (e.message !== 'cart_unknown') { writeAddNote(null); throw e; }
          return { n0: n0, already: false, unsure: true };      /* no answer: the cart below decides */
        });
      });
    }).then(function (res) {
      /* confirmed only when the cart itself holds the sign: the side cart Shopify rendered from the cart AFTER the add
         lists this variant (no further request); otherwise the cart is read, with the drawer, at the same time */
      if (res.html && res.html.indexOf('variant=' + vid) >= 0) {
        mark('confirmedByAddAnswer');
        return { cart: null, html: res.html, count: typeof res.count0 === 'number' ? res.count0 + line.quantity : null };
      }
      mark('confirmStart');
      return Promise.all([cartJSON(), drawerHTML()]).then(function (r) {
        var cart = r[0], html = r[1];
        mark('confirmEnd');
        var n = qtyOf(cart, vid);
        var need = res.already ? res.n0 + 1 : (res.n0 === null || res.n0 < 0 ? 1 : res.n0 + line.quantity);
        if (n === null || n < need) throw new Error(res.unsure ? 'cart_unknown' : 'cart_not_confirmed');
        if (res.unsure) writeAddNote(null);
        return { cart: cart, html: html };
      });
    }).then(function (ok) {
      ADDING = false;
      setBusy(true, 'Added ✓', 'is-added');
      say('Added to your cart');
      var opened = openDrawer(ok.html, ok.cart, ok.count);
      mark(opened ? 'drawerOpen' : 'toCartPage');
      window.__tnfCatLastAdd = T_ADD;
      /* the header's cart count and the theme's cart-update event get the whole cart - after the drawer is open */
      if (opened && !ok.cart) cartJSON().then(function (c) { if (!c) return; $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; }); try { document.dispatchEvent(new CustomEvent('cart-update', { detail: c })); } catch (e) {} });
      if (!opened) { setBusy(true, 'Added ✓ · opening your cart', 'is-added'); location.href = '/cart'; return; }
      setTimeout(function () { if (!ADDING) { setBusy(false); refresh(); } }, 1800);
    }).catch(function (e) {
      ADDING = false;
      if (T_ADD) { T_ADD.error = e.message; mark('error'); window.__tnfCatLastAdd = T_ADD; }
      var text = ({
        no_price_source: 'We could not confirm the price for this size, so nothing was added to your cart. Please request a quote and we will confirm the price shown.',
        no_variant: 'This exact size is not available to buy online yet. Nothing was added to your cart — please request a quote.',
        price_mismatch: 'The price for this size has been updated. Nothing was added to your cart — please review the new price and add again.',
        requote: 'The price was rechecked and has changed to ' + money(S.serverPrice) + '. Please review and add again.',
        quote_failed: 'We could not confirm the price. Nothing was added to your cart.',
        cart_rejected: 'Something went wrong adding this to your cart. Nothing was added.',
        cart_unknown: 'We couldn’t confirm your cart just now. Please open your cart to check before adding this sign again.',
        cart_not_confirmed: 'Your cart didn’t show this sign after adding it. Please open your cart to check before adding it again.',
        timeout: 'This is taking longer than usual, so we stopped waiting. Nothing was added to your cart — please press Add to cart again.',
        network: 'We couldn’t reach our order system. Please check your connection and press Add to cart again. Nothing was added to your cart.',
        busy: 'Our order system is busy right now. Please wait a moment and press Add to cart again. Nothing was added to your cart.',
        service_down: 'Our order system didn’t answer. Nothing was added to your cart — please try again in a moment.',
        dry_run: 'Test mode: the order service priced and prepared this sign but created nothing, so nothing was added to your cart.',
        price_changed: 'The price for this size has been updated. Nothing was added to your cart — please review the new price and add again.',
        below_minimum_width: 'That size is smaller than this sign is made. Nothing was added to your cart.',
        above_product_maximum: 'That size is larger than this sign is made. Nothing was added to your cart.',
        width_not_on_step: 'Please choose a whole ' + (S.market === 'US' ? 'inch' : 'centimetre') + '. Nothing was added to your cart.',
        not_ready_yet: 'Your made-to-size sign is still being set up in our store, so it couldn\u2019t go into your cart yet. Nothing was added \u2014 please press Add to cart again in a few minutes, or request a quote.',
        not_priceable: 'This configuration is priced by hand. Nothing was added to your cart — please request a quote and we will confirm the price shown.',
        quote_expired_or_invalid: 'The price check timed out. Nothing was added to your cart — please add again.',
        configuration_changed_since_quote: 'Your choices changed while we were checking the price. Nothing was added — please add again.'
      })[e.message] || 'Something went wrong. Nothing was added to your cart.';
      var m = $('#tnf-cat-msg'); m.textContent = text; m.hidden = false;
      say(text);
      setBusy(false);
      if (e.message === 'price_changed' || e.message === 'quote_expired_or_invalid') PREQ = null;
      refresh();
    });
  }

  /* ---- restore an explicitly chosen size ------------------------------- */
  function restoreWidth() {
    var p = new URLSearchParams(location.search);
    var raw = p.get('width') || p.get('w') || p.get('size');
    if (raw) {
      var n = parseFloat(raw);
      if (isFinite(n)) {
        /* a bare number is in the market's own unit; "700mm" is canonical */
        var mm = /mm$/i.test(raw) ? n : fromDisp(n);
        S.widthTouched = true; return snap(mm);
      }
    }
    return null;
  }

  /* 1.7.0: the rest of a configuration carried by a link (the cart's "View design": _tnf_cfg). Every value is checked
     against what this product offers and applied through the page's own controls, so nothing is taken on trust. */
  function restoreOptions() {
    var p; try { p = new URLSearchParams(location.search); } catch (e) { return; }
    var c = p.get('colour');
    if (c && CFG.colourMode === 'selectable' && COLOURS.some(function (x) { return x.name === c; })) selectColour(c);
    if (p.get('use') === 'outdoor') { var o = $('#tnf-cat .tnf-use[data-use="outdoor"]'); if (o) o.click(); }
    var wf = p.get('wall');
    if (wf && /^(silver|black|gold)$/.test(wf)) {
      var wb = $('#tnf-cat-wall'); if (wb && !wb.checked) wb.click();
      var fb = $('#tnf-cat-wallfin .tnf-wf[data-wf="' + wf + '"]'); if (fb) fb.click();
    }
    if (p.get('hang') === '1') { var h = $('#tnf-cat-hang'); if (h && !h.checked) h.click(); }
    if (p.get('tape') === '1') { var t = $('#tnf-cat-tape'); if (t && !t.checked) t.click(); }
    if (p.get('battery') === '1') { var b = $('#tnf-cat-battery'); if (b && !b.checked) b.click(); }
    if (p.get('dimmer') === '0') { var d = $('#tnf-cat-dimmer'); if (d && d.checked && S.battery) d.click(); }
    var pl = p.get('plug');
    if (pl && PLUGS.indexOf(pl) >= 0) { var sel = $('#tnf-cat-plug'); if (sel) { sel.value = pl; sel.dispatchEvent(new Event('change', { bubbles: true })); } }
  }

  /* ---- wiring ----------------------------------------------------------- */
  /* UNPRICED presentation: the design's own gallery, title and colour
     statement stay on the page; every size, price and cart control goes,
     and a quote route takes their place. No price, no fallback figure, no
     other product's geometry - the customer is told plainly that this design
     is priced by hand for now. Used when no measured tubing length exists,
     or when the product's own size record could not be resolved. */
  /* 1.2.0: the power adapter stays usable here (Jack, 24 Sep 2026): it is not a priced option, so it is not
     withdrawn with the size and price controls. It moves into the quote box above the button, keeps the
     market's plug as its default, and the button carries the choice (in the existing Power Adapter
     wording) into the site's enquiry form. No price is invented and no purchase path is offered. */
  function showUnpriced(reason) {
    S.unpriced = true;
    document.documentElement.classList.add('tnf-catalogue', 'tnf-catalogue-unpriced');
    var plugSel = $('#tnf-cat-plug'), plugPanel = plugSel ? plugSel.closest('.tnf-panel') : null;
    $$('#tnf-cat .tnf-panel, #tnf-cat-total, #tnf-cat-add, #tnf-cat-sticky, #tnf-cat-headprice, #tnf-cat-msg, #tnf-cat-pricechip, #tnf-cat-dims, #tnf-cat-expand, #tnf-cat-colournote').forEach(function (el) { if (el !== plugPanel) el.hidden = true; });
    var fixed = $('#tnf-cat .tnf-cat-fixedcolour');
    var controls = $('#tnf-cat .tnf-cat-controls');
    if (!controls) return;
    var box = document.createElement('div');
    box.className = 'tnf-cat-unpriced'; box.id = 'tnf-cat-unpriced';
    var minTxt = (CFG.minWidth_cm && sizeOk()) ? ' Made from ' + (S.market === 'US' ? Math.ceil(CFG.minWidth_cm / 2.54 - 1e-9) + ' in' : CFG.minWidth_cm + ' cm') + ' wide.' : '';
    box.innerHTML = (fixed ? fixed.outerHTML : '') +
      '<p class="tnf-cat-unpriced-t">Priced by hand for now</p>' +
      '<p class="tnf-cat-unpriced-p">Online pricing for this design is being finalised.' + minTxt + ' Tell us the width you would like and we will confirm the price and delivery time within one working day.</p>';
    if (plugPanel) { plugPanel.classList.add('tnf-cat-plugpanel--quote'); box.appendChild(plugPanel); }
    var a = document.createElement('a'); a.className = 'tnf-btn tnf-btn-primary tnf-cta'; a.setAttribute('data-tnf-quote', ''); a.textContent = 'Request a quote';
    box.appendChild(a);
    if (fixed) fixed.hidden = true;
    controls.appendChild(box);
    bindPlug(); bindThumbs(); syncQuoteLink();
    if (window.console && console.warn) console.warn('[tnf-cat] "' + CFG.handle + '": ' + reason);
  }

  function announce(t) { var m = $('#tnf-cat-msg'); if (!m) return; m.textContent = t; m.hidden = false; clearTimeout(announce.t); announce.t = setTimeout(function () { m.hidden = true; m.textContent = ''; }, 5000); }

  /* ---- CROP (1.2.0): the ORIGINAL photograph, seen through a window -----------------------------------
     window.TNF_CAT_FOCUS (snippets/tnf-cat-focus.liquid 1.1.0, generated from the original renders) gives,
     for each photo of this product, where the lit tube sits, in per-mille of the photo: its box
     [x0, y0, x1, y1] and a profile of the tube inside the box (16 columns, the topmost and bottommost tube
     pixel of each). The glow is the tube grown by 5 % of the sign's larger side plus 1.2 % of the photo.
     The photo always fills the stage - object-fit: cover, scaled to the stage width, never stretched, never
     letterboxed - and object-position places it so the sign (with its glow when that fits, otherwise at
     least the lit tube) sits centred in the band the chips leave free; the chips are drawn as what they are
     (pills), so a chip beside a narrow part of the sign does not push the photo. For the few photos whose
     sign sits in the top corner under the price, a uniformly closer crop (one per photo) moves the sign
     clear. No pixel of the photograph is changed. 1.4.0: a photo with no measurement is treated as if the sign
     filled it (SAFE): it is still pinned, but its compact window never gets shorter than the full picture, so a
     crop can never cut its sign. */
  var FOCUS = window.TNF_CAT_FOCUS || {};
  var CROP = (function () {
    var PAD = 6, GAP = 4, GLOW_K = 0.05, GLOW_IMG = 0.012, SAFE = [0, 0, 1000, 1000];
    var M = 8;                                          /* chip inset on phones and tablets (tnf-cat-1-2-0.css) */
    var ZMAX = 1.9, ZSTEP = 0.05;
    var last = { mode: 'none' }, pending = null;
    function heroEl() { return document.getElementById('tnf-cat-hero'); }
    function mediaId() { var h = heroEl(); return h ? h.getAttribute('data-media-id') : null; }
    function raw(id) { var f = FOCUS[String(id || '')]; return f && f.length >= 4 ? f : null; }
    function tube(id) { var f = raw(id) || SAFE; return [f[0] / 1000, f[1] / 1000, f[2] / 1000, f[3] / 1000]; }
    function prof(id) { var f = raw(id), p = f && f[4]; if (!p || !p.length) return null; var k = p.length / 2; return { t: p.slice(0, k), b: p.slice(k) }; }
    /* the photo's own pixel size: the incoming photo's while a colour change is being framed, else the hero's */
    function natural(id) {
      var h = heroEl(); id = id == null ? mediaId() : id;
      if (pending && String(pending.id) === String(id)) return { iw: pending.iw, ih: pending.ih };
      if (h && h.naturalWidth && h.complete) return { iw: h.naturalWidth, ih: h.naturalHeight };
      return { iw: +(h && h.getAttribute('width')) || 1400, ih: +(h && h.getAttribute('height')) || 1335 };
    }
    /* the sign as vertical strips in photo fractions [x0, x1, top, bottom]: the tube's measured columns (or
       its box when no profile exists), grown by the glow margin for 'glow', by a hair of halo for 'tube' */
    function strips(which, id) {
      if (id == null) id = mediaId();
      var n = natural(id), t = tube(id), p = prof(id), out = [], gx = 0, gy = 4 / Math.max(1, n.ih);
      if (which === 'glow') {
        var m = GLOW_K * Math.max((t[2] - t[0]) * n.iw, (t[3] - t[1]) * n.ih) + GLOW_IMG * Math.max(n.iw, n.ih);
        gx = m / n.iw; gy = m / n.ih;
      }
      if (p) { var k = p.t.length, cw = (t[2] - t[0]) / k; for (var i = 0; i < k; i++) if (p.t[i] >= 0) out.push([t[0] + i * cw - gx, t[0] + (i + 1) * cw + gx, p.t[i] / 1000 - gy, p.b[i] / 1000 + gy]); }
      if (!out.length) out.push([t[0] - gx, t[2] + gx, t[1] - gy, t[3] + gy]);
      out.forEach(function (s) { s[0] = Math.max(0, s[0]); s[1] = Math.min(1, s[1]); s[2] = Math.max(0, s[2]); s[3] = Math.min(1, s[3]); });
      return out;
    }
    function box(which, id) {
      var b = [1, 1, 0, 0];
      strips(which, id).forEach(function (s) { b[0] = Math.min(b[0], s[0]); b[2] = Math.max(b[2], s[1]); b[1] = Math.min(b[1], s[2]); b[3] = Math.max(b[3], s[3]); });
      return b;
    }
    /* the chips inside the stage, per state, as the stylesheet draws them (heights fixed there, widths
       measured because the price and size text change): price top-left, size bottom-left, Expand
       bottom-right while pinned; while typing only the price chip is shown. m = inset from the stage edge,
       ch = height, r = corner radius (pills: half the height) */
    /* a chip taken out of the page (hidden attribute: the quote route has no price or size chips) is no obstacle;
       one only hidden by a state's styling (typing) keeps its measured / usual width */
    function width(sel, fb) { var e = document.querySelector(sel); if (!e || e.hidden) return 0; var v = e.offsetWidth; return v > 0 ? v : fb; }
    function chip(x0, x1, side, m, ch, r) { return { x0: x0, x1: x1, side: side, m: m, ch: ch, r: Math.min(r == null ? ch / 2 : r, ch / 2) }; }
    function obstacles(W, state) {
      var o = [], small = window.innerWidth <= 640;
      var pw = width('#tnf-cat-pricechip', 92), dw = width('#tnf-cat-dims', 112), ew = width('#tnf-cat-expand', 96);
      if (state === 'typ') { if (pw) o.push(chip(M, M + pw, 'top', M, 32)); return o; }
      if (state === 'comp') {
        if (pw) o.push(chip(M, M + pw, 'top', M, 36));
        if (dw) o.push(chip(M, M + dw, 'bottom', M, 36));
        if (ew) o.push(chip(W - M - ew, W - M, 'bottom', M, 36));
      } else {
        if (pw) o.push(chip(M, M + pw, 'top', M, 40));
        if (dw) o.push(chip(M, M + dw, 'bottom', M, small ? 36 : 40));
      }
      var cn = document.getElementById('tnf-cat-colournote');
      if (cn && !cn.hidden && cn.offsetWidth) o.push(chip(W - M - cn.offsetWidth, W - M, state === 'comp' ? 'top' : 'bottom', M, cn.offsetHeight, 12));
      return o;
    }
    /* how far a chip reaches into the picture from its edge over the x-range [a, c]: its full depth over
       the straight part, less over a rounded end; -1 when it is not over that range at all */
    function reach(o, a, c) {
      a = Math.max(a, o.x0); c = Math.min(c, o.x1); if (c <= a) return -1;
      var f0 = o.x0 + o.r, f1 = o.x1 - o.r;
      if (c > f0 && a < f1) return o.m + o.ch;
      var dx = Math.min(o.r, Math.max(0, a >= f1 ? a - f1 : f0 - c));
      return o.m + o.ch - o.r + Math.sqrt(Math.max(0, o.r * o.r - dx * dx));
    }
    /* where the photo's top edge may sit (oy, px from the window top) so that every strip of the sign stays
       PAD inside the window and GAP clear of every chip: oy >= A and oy <= H - B */
    function reqs(ox, Dw, Dh, st, ob) {
      var A = -Infinity, B = -Infinity;
      st.forEach(function (s) {
        var x0 = ox + s[0] * Dw, x1 = ox + s[1] * Dw, y0 = s[2] * Dh, y1 = s[3] * Dh;
        /* 1.4.0: the PAD margin is kept only where the photo has room for it - a sign (or its glow) that reaches the
           photo's own top or bottom edge is framed flush with that edge, never counted as impossible to frame */
        A = Math.max(A, Math.min(PAD, y0) - y0); B = Math.max(B, y1 + Math.min(PAD, Math.max(0, Dh - y1)));
        ob.forEach(function (o) {
          var d = reach(o, x0, x1); if (d < 0) return;
          if (o.side === 'top') A = Math.max(A, d + GAP - y0); else B = Math.max(B, d + GAP + y1);
        });
      });
      return { A: A, B: B };
    }
    /* 1.4.0 'mix': the whole glow kept inside the window, the chips kept clear of the lit tube itself (they may lie
       over the faint outer glow) - used when the glow cannot also be kept clear of the chips, before anything of
       the glow is given up */
    function reqsFor(which, pl, id, ob) {
      if (which !== 'mix') return reqs(pl.ox, pl.Dw, pl.Dh, strips(which, id), ob);
      var a = reqs(pl.ox, pl.Dw, pl.Dh, strips('glow', id), []), b = reqs(pl.ox, pl.Dw, pl.Dh, strips('tube', id), ob);
      return { A: Math.max(a.A, b.A), B: Math.max(a.B, b.B) };
    }
    /* the photo scaled to cover the window (times z), centred on the sign horizontally within its edges */
    function place(W, H, n, bb, z) {
      var s = Math.max(W / n.iw, H / n.ih) * (z || 1), Dw = n.iw * s, Dh = n.ih * s;
      var ox = Dw > W + 0.5 ? Math.min(0, Math.max(W - Dw, W / 2 - (bb[0] + bb[2]) / 2 * Dw)) : (W - Dw) / 2;
      return { ox: ox, Dw: Dw, Dh: Dh };
    }
    /* z (Brief 6): a closer crop of the same photograph for the few photos whose sign sits in the top
       corner where the price is shown - the photo is scaled up uniformly (never stretched, never
       letterboxed) until the complete sign clears the chips. 1 for every other photo. */
    /* 1.4.0: when a closer crop leaves the photo wider than the window, the sign need not sit dead centre - the
       horizontal position closest to centre at which it clears the chips is used (a sign near the photo's top-left
       corner moves right, out from under the price, instead of being pulled back under it) */
    function oxCandidates(W, pl) {
      var c = [pl.ox]; if (pl.Dw <= W + 0.5) return c;
      for (var i = 0; i <= 12; i++) c.push((W - pl.Dw) * i / 12);
      return c;
    }
    function solve(W, H, n, which, id, ob, z) {
      var bb = box(which === 'mix' ? 'glow' : which, id), pl = place(W, H, n, bb, z), q = reqsFor(which, pl, id, ob);
      var cands = oxCandidates(W, pl);
      if (cands.length > 1 && !(Math.max(q.A, H - pl.Dh) <= Math.min(H - q.B, 0) + 0.5)) {
        var best = null;
        cands.forEach(function (ox) {
          var p2 = { ox: ox, Dw: pl.Dw, Dh: pl.Dh }, q2 = reqsFor(which, p2, id, ob);
          if (Math.max(q2.A, H - pl.Dh) <= Math.min(H - q2.B, 0) + 0.5 && (!best || Math.abs(ox - pl.ox) < Math.abs(best.ox - pl.ox))) best = { ox: ox, q: q2 };
        });
        if (best) { pl = { ox: best.ox, Dw: pl.Dw, Dh: pl.Dh }; q = best.q; }
      }
      var oy = Math.min(0, Math.max(H - pl.Dh, (q.A + H - q.B) / 2));
      var fy0 = bb[1] * pl.Dh, fy1 = bb[3] * pl.Dh;
      return { ox: pl.ox, oy: oy, Dw: pl.Dw, Dh: pl.Dh, top: Math.round(q.A), bot: Math.round(q.B),
               whole: oy + fy0 >= -0.5 && oy + fy1 <= H + 0.5, clear: oy >= q.A - 0.5 && oy <= H - q.B + 0.5 };
    }
    /* the window height the sign needs at width W (photo scaled to the width, times z); blocked when the
       photo cannot move down far enough for a top chip (a sign in the photo's top corner) */
    function need(W, n, which, id, ob, z) {
      var bb = box(which === 'mix' ? 'glow' : which, id), pl = place(W, 0, n, bb, z), q = reqsFor(which, pl, id, ob);
      if (q.A > 0.5) {
        var best = null;
        oxCandidates(W, pl).forEach(function (ox) {
          var q2 = reqsFor(which, { ox: ox, Dw: pl.Dw, Dh: pl.Dh }, id, ob);
          if (q2.A <= 0.5 && (!best || Math.abs(ox - pl.ox) < Math.abs(best.ox - pl.ox))) best = { ox: ox, q: q2 };
        });
        if (best) q = best.q;
      }
      return q.A > 0.5 ? { h: q.B, blocked: true } : { h: q.A + q.B, blocked: false };
    }
    /* the height a pinned state needs for THIS photo's sign: the glow when that fits under the cap,
       otherwise the lit tube (up to the full picture height) - a tall design gets a taller strip */
    function heightFor(state, W, base, cap, max, id, z) {
      if (id == null) id = mediaId();
      var n = natural(id), ob = obstacles(W, state);
      var g = need(W, n, 'glow', id, ob, z || 1);
      /* 1.4.0 (final brief: "preserve the entire sign and its glow"): the compact window grows up to the full
         picture height before any of the glow is given up; only the slim typing strip may fall back to the tube */
      var gcap = state === 'comp' ? max : cap;
      if (!g.blocked && g.h <= gcap) return { h: Math.min(max, Math.max(base, Math.round(g.h))), box: 'glow', needGlow: Math.round(g.h) };
      if (state === 'comp') {
        var mx = need(W, n, 'mix', id, ob, z || 1);
        if (!mx.blocked && mx.h <= max) return { h: Math.min(max, Math.max(base, Math.round(mx.h))), box: 'mix', needGlow: Math.round(g.h), needMix: Math.round(mx.h) };
      }
      var t = need(W, n, 'tube', id, ob, z || 1);
      return { h: Math.min(max, Math.max(base, Math.round(t.h))), box: 'tube', needGlow: Math.round(g.h), needTube: Math.round(t.h), blocked: t.blocked };
    }
    /* the smallest closer crop (if any) at which the complete lit sign clears the chips in BOTH the compact
       strip and the full picture - one value per photo, so nothing zooms while the page scrolls. null when
       the photo works as it is (almost all of them) or when no crop up to ZMAX would help. */
    function zoomFor(W, base, cap, gen, id) {
      if (id == null) id = mediaId();
      if (!raw(id)) return null;
      var n = natural(id), obC = obstacles(W, 'comp'), obG = obstacles(W, 'gen');
      var ok = function (r) { return r.whole && r.clear; };
      var c1 = heightFor('comp', W, base, cap, gen, id);
      if (ok(solve(W, c1.h, n, 'tube', id, obC, 1)) && ok(solve(W, gen, n, 'tube', id, obG, 1))) return null;
      for (var z = 1 + ZSTEP; z <= ZMAX + 1e-9; z += ZSTEP) {
        var which = 'glow', q = need(W, n, 'glow', id, obC, z);
        if (q.blocked || q.h > gen) { which = 'mix'; q = need(W, n, 'mix', id, obC, z); }
        if (q.blocked || q.h > gen) { which = 'tube'; q = need(W, n, 'tube', id, obC, z); }
        if (q.blocked) continue;
        var h = Math.min(gen, Math.max(base, Math.round(q.h)));
        if (ok(solve(W, h, n, 'tube', id, obC, z)) && ok(solve(W, gen, n, 'tube', id, obG, z))) return { z: Math.round(z * 100) / 100, h: h, box: which };
      }
      return null;
    }
    function set(ox, oy, z) {
      var h = heroEl(); if (!h) return; z = z || 1;
      /* the zoom is a uniform scale from the picture's top-left corner; object-position is given before it */
      var v = Math.round(ox / z * 10) / 10 + 'px ' + Math.round(oy / z * 10) / 10 + 'px';
      if (h.style.objectPosition !== v) h.style.objectPosition = v;
      var t = z > 1.001 ? 'scale(' + z + ')' : '';
      if (h.style.transform !== t) { h.style.transform = t; h.style.transformOrigin = t ? '0 0' : ''; }
    }
    /* phones / tablets: the window is the stage, W x H, in the given state */
    function apply(W, H, state, which, z) {
      var id = mediaId(), n = natural(id), ob = obstacles(W, state);
      which = which || 'glow'; z = z || 1;
      /* 1.4.0: the glow clear of the chips, else the glow in view with the chips clear of the tube ('mix'), else the tube */
      var order = which === 'tube' ? ['tube'] : which === 'mix' ? ['mix', 'tube'] : ['glow', 'mix', 'tube'], r = null, first = null;
      for (var i = 0; i < order.length; i++) {
        var ri = solve(W, H, n, order[i], id, ob, z); if (!first) first = { r: ri, w: order[i] };
        if (ri.clear && ri.whole) { r = ri; which = order[i]; break; }
        if (i === order.length - 1) { r = ri; which = order[i]; if (!ri.clear && first.r.clear) { r = first.r; which = first.w; } }
      }
      set(r.ox, r.oy, z);
      last = { mode: state, W: Math.round(W), H: Math.round(H), media: id, measured: !!raw(id), profiled: !!prof(id), box: which, ox: Math.round(r.ox), oy: Math.round(r.oy), z: z,
               top: r.top, bottom: r.bot, whole: r.whole, clear: r.clear, iw: n.iw, ih: n.ih, Dh: Math.round(r.Dh) };
      return last;
    }
    /* desktop (and phones held sideways, where the picture is not pinned): the window is the picture's own
       box; nothing to do while the whole photo is in view, otherwise the sign is framed clear of the chips */
    function desktop() {
      var h = heroEl(); if (!h || PIN.state.active) return;
      var W = h.clientWidth, H = h.clientHeight, id = mediaId(), n = natural(id);
      if (!W || !H) return;
      var Dh = n.ih * W / n.iw;
      if (!raw(id) || H >= Dh - 1) { if (h.style.objectPosition) h.style.objectPosition = ''; if (h.style.transform) { h.style.transform = ''; h.style.transformOrigin = ''; } last = { mode: raw(id) ? 'whole' : 'default-centre', W: W, H: H, media: id, measured: !!raw(id) }; return; }
      var hr = h.getBoundingClientRect(), ob = [];
      ['#tnf-cat-pricechip', '#tnf-cat-dims', '#tnf-cat-colournote'].forEach(function (sel) {
        var e = document.querySelector(sel); if (!e || e.hidden || !e.offsetWidth) return;
        var r = e.getBoundingClientRect(), top = (r.top - hr.top) < H / 2, rad = parseFloat(getComputedStyle(e).borderTopLeftRadius) || 0;
        ob.push(chip(r.left - hr.left, r.right - hr.left, top ? 'top' : 'bottom', top ? r.top - hr.top : hr.bottom - r.bottom, r.height, rad));
      });
      var r = null, which = 'glow', order = ['glow', 'mix', 'tube'];
      for (var i = 0; i < order.length; i++) { r = solve(W, H, n, order[i], id, ob, 1); which = order[i]; if (r.clear && r.whole) break; }
      if (!(r.clear && r.whole)) { var r0 = solve(W, H, n, 'glow', id, ob, 1); if (r0.clear) { r = r0; which = 'glow'; } }
      set(r.ox, r.oy, 1);
      last = { mode: 'desktop', W: W, H: H, media: id, measured: true, profiled: !!prof(id), box: which, ox: Math.round(r.ox), oy: Math.round(r.oy), top: r.top, bottom: r.bot, whole: r.whole, clear: r.clear, iw: n.iw, ih: n.ih };
    }
    /* a colour change: the incoming photo is framed with ITS size and sign position before it is shown */
    function frameFor(id, iw, ih) { pending = { id: String(id || ''), iw: iw, ih: ih }; }
    function mediaChanged() { if (PIN.state.active) PIN.mediaChanged(); else desktop(); }
    function chipsChanged() { if (PIN.state.active) PIN.chipsChanged(); else desktop(); }
    function init() {
      var h = heroEl(); if (!h) return;
      h.addEventListener('load', function () { pending = null; mediaChanged(); });
      if (window.ResizeObserver) new ResizeObserver(function () { if (!PIN.state.active) desktop(); }).observe(h);
      window.addEventListener('resize', function () { if (!PIN.state.active) desktop(); });
      desktop();
    }
    return { init: init, apply: apply, desktop: desktop, heightFor: heightFor, zoomFor: zoomFor, frameFor: frameFor, mediaChanged: mediaChanged, chipsChanged: chipsChanged,
             natural: natural, state: function () { return last; }, focus: function (id) { return raw(id == null ? mediaId() : id); } };
  })();

  /* ---- pinned preview (phones / tablets, <= 1080 px) ------------------------
     Adapted from the working creator (tnf-creator 2.5.10 PIN). The pin container (#tnf-cat-pin) keeps ONE
     flow height - the full picture height - so pinning never moves the page. 1.2.0: the picture inside it
     (#tnf-cat-stagewrap) now shrinks WITH the scroll: once the picture sticks, every pixel scrolled takes a
     pixel off its height until the compact height is reached - so the thumbnails follow directly under it
     (no empty band between picture and thumbnails) and the page never jumps. Scrolling back up grows it
     again; Expand scrolls back to the top of the picture. While the width field is typed into, a slim
     strip (tall enough for the sign) keeps the field in view above the keyboard.
     Heights come from the SMALL viewport height (100svh), which does not change while Safari's or
     Chrome's bars slide in and out, less a fixed header and the theme's bottom bar; the keyboard is read
     from the visual viewport while typing only. On a phone held sideways (under 480 px tall) the picture
     is not pinned: it is shown whole and scrolls with the page, because a pinned full-width photo there
     would either cut the sign or leave almost no room for the options. Desktop is untouched. */
  var PIN = (function () {
    var st = { active: false, typing: false, unpinned: false, gen: 0, comp: 0, typ: 0, base: 0, cap: 0, top: 0, lastH: 0, ticking: false,
               field: null, W: 0, VH: 0, d: 0, off: 0, zoom: 1, compBox: 'glow', typBox: 'glow', needGlow: 0, animT: 0 };
    var PIN_IN = 36, MIN_FIELD_ROOM = 200, SHORT = 480;
    var FIELD_SEL = '#tnf-cat-wnum';
    function els() { return { pin: $('#tnf-cat-pin'), sw: $('#tnf-cat-stagewrap'), sent: $('#tnf-cat-pinsent'), exp: $('#tnf-cat-expand') }; }
    function vvH() { return (window.visualViewport && window.visualViewport.height) || window.innerHeight; }
    function stableH() {
      var p = document.getElementById('tnf-cat-svh');
      if (!p) {
        p = document.createElement('div'); p.id = 'tnf-cat-svh'; p.setAttribute('aria-hidden', 'true');
        p.style.cssText = 'position:fixed;left:0;top:0;width:0;height:100vh;height:100svh;visibility:hidden;pointer-events:none;z-index:-1';
        document.body.appendChild(p);
      }
      var h = p.offsetHeight; return h > 0 ? h : (window.innerHeight || 700);
    }
    function isPhoneLayout() { return window.matchMedia('(max-width: 1080px)').matches; }
    function reduceMotion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    function headerOffset() {
      var best = 0, vh = vvH();
      ['sticky-header', '.header-wrapper', '#shopify-section-header', '.shopify-section-header-sticky', 'header', '.site-header'].forEach(function (sel) {
        var e = document.querySelector(sel); if (!e) return;
        var cs = getComputedStyle(e); if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
        if (cs.visibility === 'hidden' || cs.display === 'none' || parseFloat(cs.opacity) === 0) return;
        /* 1.4.0: a bar sliding in (the theme animates its sticky header down) is measured where it is going, so the
           picture never sits under it while the animation runs (as the desktop gallery has done since 1.2.0) */
        var m = /matrix\(([^)]+)\)/.exec(cs.transform || ''), ty = 0;
        if (m) { var v = m[1].split(','); ty = parseFloat(v[5]) || 0; }
        var r = e.getBoundingClientRect(), top = r.top - ty, bottom = r.bottom - ty;
        if (r.height > 0 && top <= 1 && bottom > 0 && bottom < vh * 0.5) best = Math.max(best, bottom);
      });
      return Math.round(best);
    }
    /* 1.4.0: the theme makes its header sticky a beat AFTER the scroll that triggers it (and animates it in), when
       no further scroll event may come: the page's header watcher (hdrMeasure, on scroll + 140 / 420 ms, class
       changes, animation / transition ends, resizes) calls this so the pinned picture moves below the bar at once */
    function headerChanged() {
      if (!st.active) return;
      var e = els(), t = headerOffset(); if (t === st.top || !e.pin) return;
      st.top = t; e.pin.style.setProperty('--tnf-cat-pin-top', t + 'px'); st.d = scrolled(); apply(false);
    }
    function bottomBarH() {
      var vh = vvH(), best = 0;
      if (!document.elementsFromPoint) return 0;
      [0.25, 0.5, 0.75].forEach(function (fx) {
        document.elementsFromPoint(window.innerWidth * fx, vh - 3).forEach(function (e) {
          if (!e || e === document.documentElement || e === document.body || e.closest('#tnf-cat')) return;
          var cs = getComputedStyle(e); if (cs.position !== 'fixed' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return;
          var r = e.getBoundingClientRect();
          if (r.width >= window.innerWidth * 0.6 && r.height > 0 && r.height <= 140 && r.bottom >= vh - 4 && r.top > vh * 0.5) best = Math.max(best, vh - r.top);
        });
      });
      return Math.round(best);
    }
    function room() { return Math.max(320, stableH() - bottomBarH() - headerOffset()); }
    function measure() {
      var e = els(), W = e.sw ? e.sw.clientWidth : 360, rm = room(), n = CROP.natural(), ar = n.ih / n.iw;
      /* the full picture: the photo's own proportion at this width, within 58 % of the usable height (the
         same rule as before) - fixed for the page, so the page never moves when the colour changes */
      st.gen = Math.round(Math.max(260, Math.min(W * Math.min(ar, 1.05), rm * 0.58, 720)));
      st.base = Math.min(st.gen, Math.round(Math.max(150, Math.min(rm * 0.32, 230))));
      st.cap = Math.max(st.base, Math.min(st.gen, Math.round(rm * 0.5)));
      st.W = W; st.VH = stableH(); st.room = rm;
      compact();
    }
    /* the compact height for the photo on show: its sign's own need, never below the standard strip */
    function compact() {
      var e = els(), W = e.sw ? e.sw.clientWidth : st.W;
      st.measured = !!CROP.focus();
      if (!st.measured) { st.comp = st.gen; st.compBox = 'safe'; st.needGlow = 0; st.zoom = 1; return; }
      var c = CROP.heightFor('comp', W, st.base, st.cap, st.gen);
      st.comp = c.h; st.compBox = c.box; st.needGlow = c.needGlow; st.zoom = 1;
      /* a sign in the photo's top-left corner (under the price): the closest crop that clears it, if any */
      var zf = CROP.zoomFor(W, st.base, st.cap, st.gen);
      if (zf) { st.zoom = zf.z; st.comp = zf.h; st.compBox = zf.box; }
    }
    function typingHeight() {
      var e = els(), W = e.sw ? e.sw.clientWidth : st.W, rm = Math.max(200, vvH() - st.top);
      var base = Math.min(st.gen, Math.round(Math.max(90, Math.min(rm * 0.22, 140))));
      var cap = Math.max(base, Math.min(st.gen, Math.round(vvH() - st.top - MIN_FIELD_ROOM)));
      var t = CROP.heightFor('typ', W, base, cap, st.gen, null, st.zoom);      /* at this photo's crop (1 for almost all) */
      st.typ = t.h; st.typBox = t.box;
    }
    function pinnedNow() { return st.active && !st.typing && !st.unpinned && st.d > PIN_IN; }
    function target() {
      if (st.unpinned) return st.gen;
      if (st.typing) return st.typ;
      return Math.max(st.comp, Math.min(st.gen, Math.round(st.gen - st.d)));
    }
    function apply(anim) {
      var e = els(); if (!e.pin || !e.sw || !st.active) return;
      var h = target(), pinned = pinnedNow(), typing = st.typing && !st.unpinned;
      e.pin.classList.toggle('is-pinned', pinned);
      e.pin.classList.toggle('is-typing', typing);
      e.pin.classList.toggle('is-unpinned', st.unpinned);
      e.pin.classList.toggle('is-compact', typing || (pinned && h <= st.comp + 1));
      document.documentElement.classList.toggle('tnf-cat-pinned', pinned);
      if (e.exp) { e.exp.classList.toggle('is-on', pinned); e.exp.setAttribute('aria-hidden', pinned ? 'false' : 'true'); e.exp.tabIndex = pinned ? 0 : -1; }
      root.style.setProperty('--tnf-cat-pin-clear', ((st.unpinned ? 0 : h) + st.top + 12) + 'px');
      if (anim && !reduceMotion()) { e.sw.classList.add('is-animating'); clearTimeout(st.animT); st.animT = setTimeout(function () { e.sw.classList.remove('is-animating'); }, 260); }
      if (st.lastH !== h) { st.lastH = h; e.sw.style.height = h + 'px'; }
      var state = typing ? 'typ' : (pinned ? 'comp' : 'gen');
      CROP.apply(e.sw.clientWidth || st.W, h, state, state === 'comp' ? (h <= st.comp + 1 ? st.compBox : 'glow') : (state === 'typ' ? st.typBox : 'glow'), st.zoom);
    }
    /* the pin container's own top in the page flow lies one row gap below the sentinel on phones (the buy
       box is a grid there): the picture only starts to shrink once the container itself has stuck, so its
       bottom edge and the thumbnails below move together */
    function flowOffset() {
      var e = els(); if (!e.sent || !e.pin) return 0;
      var g = e.sent.parentElement; while (g && getComputedStyle(g).display === 'contents') g = g.parentElement;
      var gap = 0; if (g) { var cs = getComputedStyle(g); if (/grid|flex/.test(cs.display)) gap = parseFloat(cs.rowGap) || 0; }
      return gap + (parseFloat(getComputedStyle(e.pin).marginTop) || 0);
    }
    function scrolled() { var e = els(); if (!e.sent) return 0; return Math.max(0, st.top - (e.sent.getBoundingClientRect().top + st.off)); }
    function deactivate() {
      var e = els(); if (!e.pin || !e.sw) return;
      if (!st.active) return;
      st.active = false; st.typing = st.unpinned = false; st.lastH = 0; st.d = 0;
      e.pin.classList.remove('is-pinned', 'is-typing', 'is-unpinned', 'is-compact');
      document.documentElement.classList.remove('tnf-cat-pinned');
      e.pin.style.height = ''; e.sw.style.height = '';
      if (e.exp) { e.exp.classList.remove('is-on'); e.exp.setAttribute('aria-hidden', 'true'); e.exp.tabIndex = -1; }
      root.style.removeProperty('--tnf-cat-pin-clear');
      var h = document.getElementById('tnf-cat-hero'); if (h) { h.style.objectPosition = ''; h.style.transform = ''; h.style.transformOrigin = ''; }
      CROP.desktop();
    }
    function layout() {
      var e = els(); if (!e.pin || !e.sw) return;
      /* 1.4.0: pinned for EVERY design - measured or not, priced or not, any colour type (Jack, final brief).
         Only a phone held sideways (under 480 px tall) shows the picture whole, for every design alike. */
      st.measured = !!CROP.focus();
      if (!isPhoneLayout() || stableH() < SHORT) {
        deactivate();
        root.classList.toggle('tnf-cat-shortscreen', isPhoneLayout());
        return;
      }
      root.classList.remove('tnf-cat-shortscreen');
      st.active = true;
      var W = e.sw.clientWidth;
      /* re-measured when the width changes (rotation, a different tablet split) or the small viewport really
         changes - never while the browser's bars slide in and out during a scroll */
      if (!st.gen || st.W !== W || Math.abs(st.VH - stableH()) > 100) measure();
      st.top = headerOffset(); e.pin.style.setProperty('--tnf-cat-pin-top', st.top + 'px');
      st.off = flowOffset();
      e.pin.style.height = st.gen + 'px';           /* the one flow height */
      st.d = scrolled();
      apply(false);
    }
    function onScroll() {
      if (st.ticking) return; st.ticking = true;
      requestAnimationFrame(function () {
        st.ticking = false; if (!st.active) return;
        var t = headerOffset(); if (t !== st.top) { st.top = t; els().pin.style.setProperty('--tnf-cat-pin-top', t + 'px'); }
        st.d = scrolled(); apply(false);
      });
    }
    function decideTyping() { st.unpinned = st.typing && (vvH() - st.top - st.typ < MIN_FIELD_ROOM); }
    function ensureFieldVisible() {
      if (!st.typing || st.unpinned || !st.field || !st.active) return;
      var e = els(); var sb = e.sw.getBoundingClientRect().bottom, fr = st.field.getBoundingClientRect();
      if (fr.top < sb + 8) window.scrollBy({ top: fr.top - (sb + 8), left: 0, behavior: 'auto' });
    }
    function onFocusIn(ev) {
      if (!st.active) return; var f = ev.target;
      if (!f || !f.matches || !f.matches(FIELD_SEL)) return;
      st.field = f; st.typing = true; typingHeight(); decideTyping(); apply(true);
      setTimeout(ensureFieldVisible, 350); setTimeout(ensureFieldVisible, 750);
    }
    function onFocusOut() {
      if (!st.typing) return;
      setTimeout(function () {
        var a = document.activeElement;
        if (a && a.matches && a.matches(FIELD_SEL)) { st.field = a; return; }
        st.typing = false; st.unpinned = false; st.field = null; st.d = scrolled(); apply(true);
      }, 60);
    }
    function onViewport() {
      if (!st.active || !st.typing) return;
      typingHeight(); decideTyping(); apply(false); setTimeout(ensureFieldVisible, 120);
    }
    function expand() {
      var e = els(); if (!e.sent) return;
      var y = window.scrollY + e.sent.getBoundingClientRect().top + st.off - st.top;
      window.scrollTo({ top: Math.max(0, y - 8), left: 0, behavior: reduceMotion() ? 'auto' : 'smooth' });
    }
    /* the photo on show changed (colour, thumbnail): its sign may need a different compact height */
    function mediaChanged() {
      if (!st.active) return;
      var was = st.comp; compact(); if (st.typing) typingHeight();
      apply(Math.abs(was - st.comp) > 2);
    }
    /* the price or size text changed width: the chips may now reach the sign */
    function chipsChanged() { if (!st.active) return; var was = st.comp; compact(); apply(Math.abs(was - st.comp) > 2); }
    function init() {
      var e = els(); if (!e.pin || !e.sw) return;
      window.addEventListener('scroll', onScroll, { passive: true });
      var lastW = window.innerWidth;
      window.addEventListener('resize', function () { if (window.innerWidth !== lastW) { lastW = window.innerWidth; st.gen = 0; } layout(); });
      window.addEventListener('orientationchange', function () { st.gen = 0; setTimeout(layout, 250); });
      if (window.visualViewport) window.visualViewport.addEventListener('resize', onViewport);
      document.addEventListener('focusin', onFocusIn); document.addEventListener('focusout', onFocusOut);
      if (e.exp) { e.exp.addEventListener('click', expand); e.exp.tabIndex = -1; e.exp.setAttribute('aria-hidden', 'true'); }
      layout(); setTimeout(function () { st.gen = 0; layout(); }, 1200);
    }
    return { init: init, layout: layout, expand: expand, mediaChanged: mediaChanged, chipsChanged: chipsChanged, headerChanged: headerChanged, state: st };
  })();

  function build() {
    if (!DESIGN) { root.hidden = true; return; }
    CROP.init();
    /* lets site-wide sheets scope rules to this template (e.g. keeping the
       fixed chat launcher off the purchase panel) without touching them */
    document.documentElement.classList.add('tnf-catalogue');
    /* 1.3.0: a design that cannot be priced yet keeps the whole configuration page (see READY) */
    S.unpriced = !READY.price;
    ukLabels();   /* 1.14.0 */
    document.documentElement.classList.toggle('tnf-catalogue-pending', !READY.price);
    document.documentElement.classList.toggle('tnf-catalogue-nocart', !CAN_BUY);
    if (!READY.price && window.console && console.info) console.info('[tnf-cat] "' + CFG.handle + '": price to be confirmed - ' + READY.code + (READY.detail ? ' (' + READY.detail + ')' : ''));
    /* 1.1.2: the theme's header only BECOMES sticky part-way down the page (the
       theme's own script adds .shopify-section-header-sticky once the visitor
       has scrolled past it), and the bar that is stuck can change height. So
       the clearance the gallery keeps under it is measured live - on every
       scroll frame, resize, zoom (visual viewport) and orientation change - from
       whatever header / announcement bar is ACTUALLY stuck to the top edge right
       now, and written to --tnf-cat-hdr, which the stylesheet turns into the
       gallery's sticky offset and its height cap. A bar that is not stuck (in
       flow near the top of the page, hidden, or slid away) contributes nothing. */
    var hdrLast = -1, hdrTick = false;
    var HDR_SEL = '[id^="shopify-section-header"], [id^="shopify-section-announcement"], .shopify-section-header-sticky, .header-wrapper, sticky-header, .site-header, .announcement-bar';
    function hdrMeasure() {
      var h = 0, vh = window.innerHeight || 800;
      $$(HDR_SEL).forEach(function (el) {
        if (el.closest('#tnf-cat')) return;
        var cs = getComputedStyle(el);
        if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
        if (cs.visibility === 'hidden' || cs.display === 'none' || parseFloat(cs.opacity) === 0) return;
        var r = el.getBoundingClientRect();
        /* 1.2.0: a bar that is sliding in (the theme animates its sticky header down from above) is measured where
           it is going, not where the animation has got to, so the picture makes room at once instead of ~0.4 s later */
        var m = /matrix\(([^)]+)\)/.exec(cs.transform || ''), ty = 0;
        if (m) { var v = m[1].split(','); ty = parseFloat(v[5]) || 0; }
        var top = r.top - ty, bottom = r.bottom - ty;
        if (r.height <= 0 || bottom <= 0 || top > 2 || bottom > vh * 0.6) return;
        h = Math.max(h, bottom);
      });
      h = Math.max(0, Math.min(320, Math.round(h)));
      if (h !== hdrLast) { hdrLast = h; root.style.setProperty('--tnf-cat-hdr', h + 'px'); }
      PIN.headerChanged();
    }
    var hdrLate = 0;
    function hdrClear() {
      if (!hdrTick) { hdrTick = true; requestAnimationFrame(function () { hdrTick = false; hdrMeasure(); }); }
      /* the theme's header script settles its sticky state a beat after the
         scroll event (it acts on every other event and animates the bar in),
         so measure again shortly after the last scroll / resize */
      clearTimeout(hdrLate); hdrLate = setTimeout(hdrMeasure, 140);
      setTimeout(hdrMeasure, 420);
    }
    hdrMeasure();
    window.addEventListener('scroll', hdrClear, { passive: true });
    window.addEventListener('resize', hdrClear);
    window.addEventListener('orientationchange', function () { setTimeout(hdrMeasure, 250); });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', hdrClear);
    if (window.MutationObserver) {
      /* the header section toggles .shopify-section-header-sticky / -hidden by class */
      var hdrMo = new MutationObserver(hdrClear);
      $$(HDR_SEL).forEach(function (el) { hdrMo.observe(el, { attributes: true, attributeFilter: ['class', 'style'] }); el.addEventListener('animationend', hdrClear); el.addEventListener('transitionend', hdrClear); });
    }
    if (window.ResizeObserver) {
      var hdrRo = new ResizeObserver(hdrClear);
      $$(HDR_SEL).forEach(function (el) { hdrRo.observe(el); });
    }
    setTimeout(hdrMeasure, 1200);

    /* No invented fallback. If this product's smallest offered size could not
       be resolved from its own metafields - missing, self-contradictory, or a
       ladder that runs backwards - the catalogue control does not render and
       the legacy buy box stands. The reason is logged so the product can be
       fixed, not guessed at. */
    /* 1.3.0: a size record that is missing or contradicts itself takes away the size control only (a width and
       height would be a guess); the panel says so and every other option stays */
    if (!READY.size) {
      var wc = $('#tnf-cat .tnf-widthctl');
      if (wc) {
        wc.hidden = true;
        var sn = document.createElement('p'); sn.className = 'tnf-note tnf-cat-sizenote';
        sn.textContent = 'Sizes for this design are confirmed with your quote.';
        wc.parentNode.insertBefore(sn, wc.nextSibling);
      }
    }

    /* 1.2.0 (Jack, 24 Sep 2026 - supersedes the earlier "keep the default selection"): the page OPENS AT
       THE PRODUCT'S VERIFIED MINIMUM - its smallest offered size, CFG.minWidth_cm, resolved in Liquid from
       that size's own dimension record (never the cheapest or in-stock variant, never a geometry-derived
       smaller size, never Medium or the reference measurement). minW() puts it on this market's grid: AU
       whole cm, US the physical minimum rounded UP to a whole inch. The price shown on opening is the
       engine price of exactly that configuration with only the included options (indoor, free dimmer and
       remote, the market's plug, no kit) - the configuration the product card prices. Nothing is carried
       from another product or an earlier visit; the customer's own adjustment is kept while they stay on
       the page. Only an explicit ?width= in the address (a deliberate link) opens elsewhere, clamped the
       same way as every other input. */
    if (READY.size) {
      var restored = restoreWidth();
      S.width_mm = restored != null ? restored : minW();
      S.width_mm = Math.min(maxW(), Math.max(minW(), S.width_mm));
    } else S.width_mm = 0;

    renderColours();
    syncWidthUI();

    $('#tnf-cat-w').addEventListener('input', function (e) { setWidth(fromDisp(Number(e.target.value)), true); });
    $('#tnf-cat-wdec').addEventListener('click', function () { setWidth(S.width_mm - step_mm(), true); });
    $('#tnf-cat-winc').addEventListener('click', function () { setWidth(S.width_mm + step_mm(), true); });
    var num = $('#tnf-cat-wnum');
    num.addEventListener('change', function () {
      setWidth(fromDisp(parseFloat(num.value) || 0), true);
      /* 'change' only fires when the value is COMMITTED (Enter or leaving the
         field), never per keystroke, so it is safe to correct the box here.
         syncWidthUI deliberately skips a focused field so it cannot fight a
         user mid-type; without this line a clamped entry would leave the box
         showing a width the sign is not. */
      num.value = String(Math.round(toDisp(S.width_mm)));
    });
    num.addEventListener('blur',   function () { syncWidthUI(); });
    /* 1.6.2: the purchase bar steps aside while a width is typed (it slid up over the box on short screens) */
    num.addEventListener('focus', function () { document.documentElement.classList.add('tnf-cat-typing'); });
    num.addEventListener('blur',  function () { document.documentElement.classList.remove('tnf-cat-typing'); });

    $$('#tnf-cat .tnf-use').forEach(function (b) {
      b.addEventListener('click', function () {
        S.outdoor = b.dataset.use === 'outdoor';
        $$('#tnf-cat .tnf-use').forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
        refresh(); syncWidthUI();
      });
    });

    /* power adapter: the creator's select behaviour - change = the chosen plug, everything else untouched */
    bindPlug();
    var wall = $('#tnf-cat-wall'), fins = $('#tnf-cat-wallfin');
    wall.addEventListener('change', function () { S.wallMount = wall.checked; fins.hidden = !wall.checked; refresh(); });
    fins.hidden = true;
    $$('.tnf-wf', fins).forEach(function (b) {
      b.addEventListener('click', function () {
        S.wallFinish = b.dataset.wf;
        $$('.tnf-wf', fins).forEach(function (o) { o.setAttribute('aria-checked', String(o === b)); });
        var img = $('#tnf-cat-wallimg');
        if (img && b.dataset.img) img.src = b.dataset.img;
        refresh();
      });
    });
    $('#tnf-cat-hang').addEventListener('change', function (e) { S.hanging = e.target.checked; refresh(); });
    $('#tnf-cat-tape').addEventListener('change', function (e) { S.tape = e.target.checked; refresh(); });
    /* dimmer and battery - both allowed, at least one selected (the working creator's rule) */
    var dim = $('#tnf-cat-dimmer'), bat = $('#tnf-cat-battery');
    dim.addEventListener('change', function () {
      if (!dim.checked && !S.battery) { dim.checked = true; announce('Keep the free dimmer and remote, or add the battery pack, so the sign can be powered.'); return; }
      S.dimmer = dim.checked; refresh();
    });
    if (bat) bat.addEventListener('change', function () {
      if (!bat.checked && !S.dimmer) { bat.checked = true; announce('Keep the battery pack, or add the free dimmer and remote, so the sign can be powered.'); return; }
      S.battery = bat.checked; refresh();
    });

    restoreOptions();                         /* 1.7.0: the cart's "View design" link reopens this exact configuration */
    addToCartSetup();                         /* 1.11.0: preconnect to the order service, the Adding... style */
    $('#tnf-cat-add').addEventListener('click', addToCart);
    var sb = $('#tnf-cat-sticky');
    if (sb) {
      sb.querySelector('button').addEventListener('click', function () { addToCart(); });
      /* The bar is a stand-in for the price and button while BOTH are out of
         view: it appears once the head price row (top of the panel) has
         scrolled away and the summary is not on screen, and it goes as soon as
         either is visible - so there are never two visible prices or buttons,
         and a desktop page opens without a floating card over the options. */
      if ('IntersectionObserver' in window) {
        var seen = { head: false, total: false };
        function syncBar() {
          var on = !seen.head && !seen.total;
          sb.classList.toggle('is-visible', on);
          document.documentElement.classList.toggle('tnf-sticky-on', on);
        }
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (e.target.id === 'tnf-cat-total') seen.total = e.isIntersecting;
            else seen.head = e.isIntersecting;
          });
          syncBar();
        }, { threshold: 0.2 });
        io.observe($('#tnf-cat-total'));
        var hp = $('#tnf-cat-headprice'); if (hp) io.observe(hp);
      } else { sb.classList.add('is-visible'); }
    }

    /* The theme has its own fixed mobile toolbar. Measure it and sit the
       purchase bar clear of it, so neither covers the other and neither
       covers the summary. Re-measured on resize and orientation change. */
    function clearBottomBars() {
      var h = 0, vh = window.innerHeight;
      /* .halo-sticky-toolbar-mobile is the theme's own bottom toolbar (fixed,
         bottom:0, z-index 99, shown at every width up to 1024px). The
         preview-bar ids are Shopify's own theme-preview bar, which exists only
         while a draft theme is being previewed: counting it keeps the purchase
         bar visible to reviewers and changes nothing for customers. */
      $$('.halo-sticky-toolbar-mobile, #shopify-section-halo-toolbar-mobile, .halo-toolbar-mobile, #preview-bar-iframe, #PBarNextFrameWrapper').forEach(function (el) {
        var cs = window.getComputedStyle(el);
        if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden' || !el.offsetHeight) return;
        var r = el.getBoundingClientRect();
        /* pinned to the bottom edge and at least partly on screen */
        if (r.bottom >= vh - 2 && r.top < vh) h = Math.max(h, Math.ceil(vh - r.top));
      });
      root.style.setProperty('--tnf-cat-sb-bottom', h + 'px');
      document.documentElement.style.setProperty('--tnf-cat-sb-bottom', h + 'px');
    }
    var cbbTimer = null;
    function clearBottomBarsSoon() { if (cbbTimer) return; cbbTimer = setTimeout(function () { cbbTimer = null; clearBottomBars(); }, 120); }
    clearBottomBars();
    window.addEventListener('resize', clearBottomBars);
    window.addEventListener('orientationchange', clearBottomBars);
    window.addEventListener('scroll', clearBottomBarsSoon, { passive: true });
    setTimeout(clearBottomBars, 1200);
    setTimeout(clearBottomBars, 3000);

    bindThumbs();
    /* 1.2.0: a promotion starting, ending or ceasing to apply while the page is open re-renders every price
       from the quote (tnf-promo 1.1.0 fires tnf:promo-change at the exact start / end time); the load event,
       returning to the tab and a 30 s safety check catch anything else */
    window.addEventListener('load', PROMO.recheck);
    document.addEventListener('tnf:promo-change', PROMO.recheck);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) PROMO.recheck(); });
    setInterval(PROMO.recheck, 30000);
    /* the opening colour shows its own image too, when the product has one */
    if (CFG.colourMode === 'selectable' && S.colour) showColourMedia(S.colour);

    var chip = $('#tnf-cat-pricechip');
    if (chip) chip.addEventListener('click', function () { var t = $('#tnf-cat-total'); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'center' }); });

    refresh();
    PIN.init();
  }

  /* Read-only inspection point for automated verification. It renders nothing,
     changes nothing and accepts no input: it reports what the page would price,
     show and send for the CURRENT selection, straight from the same functions
     the page itself uses, so a test cannot be told one thing and the customer
     another. Nothing here is visible in the customer interface. */
  /* read-only diagnostic: the exact body the service branch would POST to /quote and /order (never customer content) */
  window.__tnfCatQuoteCfg = function () { return DESIGN ? quoteCfg() : null; };
  window.__tnfCatInspect = function () {
    if (!DESIGN) return { design: null, hidden: root.hidden };
    return {
      market: S.market, width_mm: S.width_mm, height_mm: height_mm(),
      minW_mm: minW(), maxW_mm: maxW(), minPhysical_mm: minPhysical_mm(),
      label: dimsLabel(), factorySize: factorySize(), properties: properties(),
      permitted: widthIsPermitted(), outdoor: S.outdoor, colour: S.colour,
      design: { ref: [DESIGN.refWidth_mm, DESIGN.refHeight_mm], min: DESIGN.minWidth_mm, max: DESIGN.maxWidth_mm, largestOption: DESIGN.largestOption_mm,
                tubing: DESIGN.tubing_m_at_ref, geometrySource: DESIGN.geometrySource, tubingSource: DESIGN.tubingSource },
      battery: S.battery, dimmer: S.dimmer, unpriced: !!S.unpriced, ready: READY, widthTouched: !!S.widthTouched,
      canBuy: CAN_BUY, order: ORDER.source, sizeResolved: sizeOk(), refSize: CFG.refSizeName || null, factorySize: READY.size ? factorySize() : null,
      sizeModel: MODEL ? { ok: MODEL.ok, min_cm: MODEL.min_cm, minName: MODEL.minName, ratio: MODEL.ratio, ref: MODEL.ref, isolated: MODEL.isolated, resolved: MODEL.resolved } : null,
      pin: { measured: !!PIN.state.measured, active: PIN.state.active, pinned: PIN.state.active && !PIN.state.typing && !PIN.state.unpinned && PIN.state.d > 36, typing: PIN.state.typing, unpinned: PIN.state.unpinned, gen: PIN.state.gen, comp: PIN.state.comp, base: PIN.state.base, cap: PIN.state.cap, d: PIN.state.d, off: PIN.state.off, top: PIN.state.top, zoom: PIN.state.zoom, h: PIN.state.lastH, compBox: PIN.state.compBox, needGlow: PIN.state.needGlow, room: PIN.state.room },
      heroMediaId: ($('#tnf-cat-hero') || {}).getAttribute ? $('#tnf-cat-hero').getAttribute('data-media-id') : null, colourMedia: Object.keys(CFG.colourMedia || {}),
      colourMediaOverride: CFG.colourMediaOverride.slice(), colourMediaMap: CFG.colourMedia || {}, crop: CROP.state(), focus: CROP.focus(), promo: S.promo || null, promoKey: S.promoKey || '', plug: S.plug, plugProperty: plugProperty(), quoteHref: quoteHref()
    };
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();
